import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Pipe,
  PipeTransform,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EmployeeTooltipDialogComponent } from '../employee-tooltip-dialog/employee-tooltip-dialog.component';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif, Subject } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import {
  calculateFiscalYear,
  formatYearRanges,
} from 'src/app/shared/commen-function-file';
import { LoginComponent } from 'src/app/login/login/login.component';
import { debounceTime } from 'rxjs';
import {
  ColDef,
  ExcelExportParams,
  GridReadyEvent,
  ISetFilterParams,
  themeQuartz,
  ValueFormatterParams,
  CellStyle,
  CellStyleFunc,
} from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { GridApi } from 'ag-grid-community';

@Component({
  selector: 'app-nine-box',
  templateUrl: './nine-box.component.html',
  styleUrls: ['./nine-box.component.scss'],
})
export class NineBoxComponent implements OnInit {
  @ViewChild('dashboardComp') dashboardComponent: any;
  selectedTypeTabName: any = 'Dashboard'; // Set default to Dashboard
  selectedTypeTabIndex: number = 0;
  buttonColorName: any;
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  userId: any;
  loggedInUserName: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  originalData: any;
  showSetupPopup: boolean = false;
  competencyListManagerView: any;
  showImportPopup: boolean = false;
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];
  frequencyDeptName: any = [];
  comparisonEmpIdsForSecondLast: any = [];
  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  selectedYearForGraphOneHRAdmin: any = null;
  fromYear: any = null;
  toYear: any = null;
  isPotentialGrid: { [key: number]: boolean } = {};
  isCheckPerformancePotential: { [key: number]: boolean } = {};
  isPotentialGridFormDisabled: boolean = false;
  isPositioning: boolean = false;
  isPositioningFormDisabled: boolean = false;
  getListOfDepartmentsOfComp: any = [];
  departmentsColor: any = [];
  selectDepartmentsColor: any = [];
  selectedYear: any;
  element: any;
  allDepartmentColor: any = [];
  getListOfBandName: any = [];
  checkPotentialGridUrl: any = [];
  errorMessage: any = [];
  errorMediumMessage: any = [];
  errorHighMessage: any = [];
  potentialGridUrl: any;
  isPerformanceUpdateBtn: { [key: number]: boolean } = {};
  isPerformanceSaveBtn: { [key: number]: boolean } = {};
  isInValidLowMinMaxRange: { [key: number]: boolean } = {};
  isInValidMediumMinMaxRange: { [key: number]: boolean } = {};
  isInValidHighMinMaxRange: { [key: number]: boolean } = {};
  isPositioningEditBtn: { [key: number]: boolean } = {};
  isInputPositioning: { [key: number]: boolean } = {};
  isPositioningSaveBtn: { [key: number]: boolean } = {};
  isPositioningCheckCloseIcon: { [key: number]: boolean } = {};
  isInputQuestions: boolean[][] = [];
  isQuestionsEditBtn: boolean[][] = [];
  isQuestionsCheckCloseIcon: boolean[][] = [];
  isQuestionsSaveBtn: boolean[][] = [];
  isFreezForHOD: boolean = false;
  isShowMD: any;
  isBandDisabled: boolean = true;
  isEmployeeDisabled: boolean = true;
  bandsList: any[] = [];
  nineboxData: any = [];
  performanceDta: any = [];
  dumpReportData: any;
  hoveredEmployees: string[] = [];
  hoveredIndex: number | null = null;
  showPopup: boolean = false;
  popupStyle = {};
  employeetrendAccrossyear: any = [];
  arrDumpReport: { [key: string]: any[] } = {};
  arrTrendReport: any[] = [];
  selectedDepartments: any = [];
  selectedDepartmentsNineBoxMaster: any = [];
  selectedPerformanceDepartments: any = [];
  allDepartmentsList: any = [];
  arrNineBoxMasterFor9BoxData: any = [];
  arrNineBoxMasterData: any = [];
  employeesData: any = [];
  arrHODByUserList: any = [];
  intHODempCode: any | null;
  arrPerformanceVsPotentialReport: any = [];
  uniqueBands: any[] = [];
  selectedBands: any[] = [];
  uniqueEmployees: any[] = [];
  selectedPerformanceEmployee: any = [];
  forHodfreezeEmployees: any = [];
  getemployeeDetails: any;
  editedIndividualScoreId: number | null = null;
  editedPerfvsPotential: number | null = null;
  editedScoreId: string | null = null;
  closeScore: any = null;
  nineBoxesNames: any;
  potentialScoreLength: any;
  performanceScoreLength: any;
  totalWeightage: number[] = [];
  performancePotentialLength: any;
  forDuplicateCheckarrAllQuestions: any = [];
  arrUserIds: any = [];
  loggedInUserDepartment: any | null;
  emptyDepartment: number = 1;
  bandNotFound: boolean = true;
  reloadKey: number = 0;
  hodDepartments: any = [];
  flattenedData: any[] = [];
  flattenedTrendData: any[] = [];
  trendGridApi: any;
  questionsArray1: any[] = [];
  flattenedDataByDept: { [dept: string]: any[] } = {};
  nineBoxGridApi!: GridApi;
  openedDumpIndex: number | null = null;

  onNineBoxGridReady(event: GridReadyEvent) {
    this.nineBoxGridApi = event.api;
  }
  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EmployeeTooltipDialogComponent>,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService
  ) {}

  ngOnInit() {
    this.flattenTrends();
    setTimeout(() => {}, 1000);
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(
      this.encryptionService.decryptData(
        sessionStorage.getItem('loggedInUserCompanyID')
      )
    );
    this.loggedInCompanyFiscalyear = sessionStorage.getItem(
      'loggedInCompanyFiscalyear'
    );
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(
        this.loggedInCompanyFiscalyear
      );
    }

    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem(
      'loggedInCompanyMDCode'
    );
    this.loggedInUserDepartment = sessionStorage.getItem('department');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(
        this.loggedInUserRole
      );
    }
    this.activatedroute.queryParams.subscribe((params) => {
      if (params['refresh']) {
        this.defaultCallFunctionsList(); // <-- This reloads your data
      }
    });
    if (
      this.loggedInUserRole == 'Super Admin' ||
      this.loggedInUserRole == 'Admin' ||
      this.loggedInUserRole == 'HR Admin'
    ) {
      this.emptyDepartment = 1;
    } else {
      if (this.loggedInUserDepartment == 'null') {
        this.emptyDepartment = 0;
      }
    }
    this.loggedInUserRoles = JSON.parse(
      sessionStorage.getItem('loggedInUserRoles') || '[]'
    );
    this.loggedInCompanyReviewCycle =
      sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    // this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    this.intHODempCode = sessionStorage.getItem('empCode');

    if (this.loggedInUserRoles?.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (
          this.loggedInUserRoles[i]?.displayName == 'Employee' ||
          this.loggedInUserRole == 'Manager' ||
          this.loggedInUserRole == 'MD'
        ) {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }
    this.getpmsyearlist();
    this.fetchKpiScore();
    const stored = localStorage.getItem('frozenDepartments');
    this.frozenDepartments = stored ? JSON.parse(stored) : {};
  }

  //   ngAfterViewInit() {
  //   if (this.selectedTypeTabName === 'Dashboard' && !this.router.url.includes('Setup')) {
  //     this.callDashboardMethod();
  //   }
  // }

  // ngOnChanges() {
  //   this.callDashboardMethod();
  // }

  // callDashboardMethod() {
  //   if (this.dashboardComponent && this.dashboardComponent.refreshData) {
  //     this.dashboardComponent.refreshData(); // custom method in dashboard component
  //   }
  // }

  openDialog(
    message: string,
    buttonText: string = 'OK',
    buttonColor: string = 'red',
    showSuccessIcon: boolean = false,
    showSuccessMessage: boolean = false,
    showCloseIcon: boolean = false
  ) {
    return this.dialog.open(ConfirmationPopupComponent, {
      disableClose: false,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: buttonText,
        btn2BgColor: buttonColor,
        showSuccessIcon: showSuccessIcon,
        showSuccessMessage: showSuccessMessage,
        showCloseIcon: showCloseIcon,
      },
    });
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    if (event.index !== 0) {
      this.selectDepartname = null;
      this.nineboxData = [];
      this.questionsArray1 = [];
    }
    // if (this.selectedTypeTabName === 'Dashboard' && this.dashboardComponent) {
    //   this.dashboardComponent.reloadDashboard();
    // }
    this.dumpreport();
    this.getDepartmentData();
  }

  selectedTypeTabIndexForReport: any;
  selectedTypeTabNameForReport: any = 'dumpReport';

  tabTypeChangedForReport(event: MatTabChangeEvent) {
    this.selectedTypeTabNameForReport = event.tab.textLabel;
    this.selectedTypeTabIndexForReport = event?.index;
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/nineBox', { operation: operation }]);

    this.getAllQuestions();
  }

  // --------------------------------- OnCLick Back FOr Setup --------------------------------------------

  onClickback() {
    this.router.navigateByUrl(
      '/home/hrportal/nineBox?refresh=' + new Date().getTime()
    );
    // this.router.navigateByUrl('/home/hrportal/nineBox');
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      let checkmoduleName: any = [];
      let storedData = sessionStorage.getItem('sidebarNames');
      if (storedData) {
        checkmoduleName = JSON.parse(storedData); // Convert JSON string to object
      }
      let modulename = checkmoduleName.filter(
        (elm: any) => elm.moduleName == '9 Box'
      );
      var tab = modulename[0].moduleName;
      if (tab === '9 Box') {
        this.selectedTypeTabName = 'Dashboard';
        this.selectedTypeTabIndex = 0;
      }
      if (params?.operation === 'Setup') {
        if (
          this.loggedInUserRole === 'HR Admin' ||
          this.loggedInUserRole === 'Super Admin' ||
          this.loggedInUserRole === 'PHI Admin' ||
          this.loggedInUserRole === 'MD'
        ) {
          this.showSetupPopup = true;
        }
      }
    });
  }

  getpmsyearlist() {
    this.httpService
      .callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID)
      .subscribe((data: any) => {
        const allYears = formatYearRanges(data?.data?.yearRanges);
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(
          this.loggedInCompanyFiscalyear
        );
        const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
        this.pmsYears = allYears.filter((yearObj: any) => {
          const [start] = yearObj.year.split('-').map(Number);
          return start <= fiscalStartYear;
        });
        const yearValue = currentFiscalYear;
        this.setSelectedYear(yearValue);
      });
  }

  isCurrentYearSelected: boolean = false;

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find(
      (ele: any) => ele.year === yearValue
    );
    if (selectedYearObj) {
      this.selectedYear = this.selectedYearForCompetency =
        selectedYearObj?.year;

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(
        this.loggedInCompanyFiscalyear
      );
      const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
      this.isCurrentYearSelected =
        this.selectedYearForCompetency === currentFiscalYear;

      const test = this.selectedYearForCompetency?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();

      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  defaultCallFunctionsList() {
    if (this.loggedInUserRole == 'HOD') {
      this.getfreezeEmployees();
    }
    this.loadNineBoxData();
    this.getDepartmentsByCompany();
    this.getBandsByCompany();
    this.getPerfPotential();
    this.getPerfPerformance();
    this.getPositioningList();

    // -------------------------
    //  this.getDepartmentList();
    this.getDepartmentData();

    this.fetchHODByUserList();
    this.loadDataFromStorage();
    this.recalculateTotalWeightage();
    if (
      this.loggedInUserRole == 'Employee' ||
      this.loggedInUserRole == 'Manager' ||
      this.loggedInUserRole == 'MD'
    ) {
      this.getAllQuestionsForReport();
    }
  }

  // ----------------For update the KPI Score-----------------

  fetchKpiScore() {
    this.pmsYears.forEach((results: any) => {
      let years = results?.year;
      let arrYear = years?.split('-');

      if (arrYear?.length !== 2) {
        return;
      }

      const apiUrl = `${this.config.getAllEmployeeDumpReports}/${this.loggedInCompanyFiscalyear}/${years}/${this.loggedInUserCompanyID}`;

      this.httpService.callGetService(apiUrl).subscribe({
        next: (response: any) => {
          if (response && response?.data) {
            const arrAllDumpReport = response?.data;

            let userIdsForSuperAdmin = [];
            if (arrAllDumpReport?.length != 0) {
              userIdsForSuperAdmin = arrAllDumpReport?.map(
                (emp: any) => emp.userId
              );

              let request = {
                compId: this.loggedInUserCompanyID,
                fromYear: Number(arrYear[0]),
                month: [],
                search: null,
                toYear: Number(arrYear[1]),
                userId: userIdsForSuperAdmin.map(String),
              };

              this.httpService
                .callPostService(this.config.getMonthYTDReport, request)
                .subscribe((data: any) => {
                  if (data?.status) {
                    const employeesData = data?.data?.employeeResponse || [];
                    if (employeesData?.length != 0) {
                      employeesData?.forEach((emp: any) => {
                        // if (emp.ytd) {
                        const resultUser = arrAllDumpReport?.find(
                          (resp: any) => resp?.employeeId == emp?.employeeId
                        );

                        if (resultUser) {
                          let intUserId = resultUser?.userId;
                          let kpiScore = emp.ytd;
                          let strYear = arrYear[0] + '-' + arrYear[1];

                          const payload = {
                            userId: parseInt(intUserId),
                            kpiScore: kpiScore,
                            year: strYear,
                          };

                          this.httpService
                            .callPutService(
                              `${this.config.updateKpiScore}`,
                              payload
                            )
                            .subscribe(
                              (data: any) => {
                                this.dumpreport();
                                this.getEmployeeTrends();
                                this.loadNineBoxData();
                                this.getPerformanceVsPotential();
                              },
                              (error: any) => {}
                            );
                        }
                        // }
                      });
                    }
                  }
                });
            }
          }
        },
        error: (err: any) => {},
      });
    });
  }

  getYearSetupForDumpReport(year: any) {
    this.selectedYear = year;
    this.selectedYearForCompetency = year;
    this.dumpreport();
  }

  fetchPerformancPotenialReport(year: any) {
    this.selectedYear = year;
    this.selectedYearForCompetency = year;
    this.getPerformanceVsPotential();
  }

  getYearSetupForReimbursement(year: any) {
    this.selectedYearForCompetency = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(
      this.loggedInCompanyFiscalyear
    );
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;

    this.getAllBoxbyCompany();
    this.getPerfPotential();
    this.getPerfPerformance();
    this.getPositioningList();
    this.getAllQuestions();
  }

  frozenDepartments: { [departmentName: string]: boolean } = {};

  vpApproval(relatedToName: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to ' + relatedToName + '?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let apiUrl = `${this.config.freezeDepartment}`;

        const params = {
          department: this.selectDepartname,
          companyId: this.loggedInUserCompanyID,
          isFrozen: true,
          year: this.selectedYearForCompetency,
          fiscalYear: this.loggedInCompanyFiscalyear,
        };

        this.httpService.callPostService(apiUrl, params).subscribe({
          next: async (result: any) => {
            const key = `${params.department}_${params.companyId}_${params.year}`;
            this.frozenDepartments[key] = true;
            localStorage.setItem(
              'frozenDepartments',
              JSON.stringify(this.frozenDepartments)
            );
            this.openDialog(
              'HOD freezed successfully',
              'OK',
              this.buttonColorName,
              false,
              false,
              false
            );
          },
          error: async (err: any) => {
            this.openDialog(
              err.error.message,
              'OK',
              'red',
              false,
              false,
              false
            );
          },
        });
      }
    });
  }

  showAsset(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '260vw';
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.disableClose = false;
    dialogConfig.data = {
      operation: event ? 'Update' : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      assetId: event,
    };
  }
  onClickLogs(moduleName: any) {
    this.router.navigate([
      '/home/hrportal/ninebox-log',
      { moduleName: moduleName, id: 0 },
    ]);
  }

  assettabaleheader = [
    { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
    { label: 'Band', isMandatory: true, sortingName: 'bands' },
    {
      label: 'Allocating Department',
      isMandatory: true,
      sortingName: 'authorityDepartment',
    },
    { label: 'Autority Name', isMandatory: true, sortingName: 'authorityName' },
    { label: 'Action' },
  ];

  sortOrder: { [key: string]: 'asc' | 'desc' } = {};
  onSortAssending(sortKey: any): void {
    this.sortOrder[sortKey] =
      this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }

  onSortDesending(sortKey: any): void {
    this.sortOrder[sortKey] =
      this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }

  onSortDesendingForasset(sortKey: any) {
    this.sortOrder[sortKey] =
      this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }

  onSortAssendingForAsset(sortKey: any) {
    this.sortOrder[sortKey] =
      this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }
  // Sort order state

  selectedAssetName = '';
  displayedColumns: string[] = ['assetName'];
  employeeColumns: string[] = ['name', 'email'];

  displayedgboxColumns: string[] = ['departmentName', 'departmentColor'];

  // getDepartmentsByCompany() {
  //   this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.getListOfDepartmentsOfComp = [];
  //     data?.data?.forEach((ele: any) => {
  //       let obj = {
  //         departmentName: ele,
  //         departmentColor: '#ffffff'
  //       }
  //       this.getListOfDepartmentsOfComp.push(obj);
  //     });

  //     // this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
  //     this.getAllBoxbyCompany();
  //   })
  // }

  getDepartmentsByCompany() {
    this.httpService
      .callGetService(
        this.config.getDepartmentsByCompany + this.loggedInUserCompanyID
      )
      .subscribe((data: any) => {
        this.getListOfDepartmentsOfComp = [];
        data?.data?.forEach((ele: any) => {
          this.getListOfDepartmentsOfComp = data?.data || [];
        });

        // this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
        this.getAllBoxbyCompany();
      });
  }

  getAllBoxbyCompany() {
    this.httpService
      .callGetService(
        this.config.getAllBoxbyCompanyId +
          this.loggedInCompanyFiscalyear +
          '/' +
          this.selectedYearForCompetency +
          '/' +
          this.loggedInUserCompanyID
      )
      .subscribe((resp: any) => {
        const backendData = resp?.data;
        this.allDepartmentColor = backendData;

        this.departmentsColor = this.getListOfDepartmentsOfComp?.map(
          (elm: any) => {
            let matchRecord = backendData?.find(
              (record: any) => record?.departmentName == elm?.departmentName
            );
            return {
              ...elm,
              id: matchRecord ? matchRecord?.id : elm?.id || null,
              departmentColor: matchRecord
                ? matchRecord?.departmentColor
                : '#ffffff',
            };
          }
        );
      });
  }

  checkDepartmentColor: any = [];
  isSaveDisabled: boolean = true;

  displayedThirdTableColumns: string[] = [
    'category',
    'low',
    'medium',
    'high',
    'action',
  ];

  PerfvsPotentialGrid = [
    {
      category: 'PMS performance score (approved by manager)',
      type: 'performance',
      ppId: '',
      performanceScoreLowMin: '',
      performanceScoreLowMax: '',
      performanceScoreMediumMax: '',
      performanceScoreHighMax: '',
    },
    {
      category: 'Potential score',
      type: 'Potential',
      potentialId: '',
      performanceScoreLowMin: '',
      performanceScoreLowMax: '',
      performanceScoreMediumMax: '',
      performanceScoreHighMax: '',
    },
  ];

  positions = [
    {
      positioning: 'Low performance high potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'Medium performance high potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'High performance high potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'Low performance medium potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'Medium performance medium potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'High performance medium potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'Low performance low potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'Medium performance low potential',
      name: '',
      positioningId: '',
    },
    {
      positioning: 'High performance low potential',
      name: '',
      positioningId: '',
    },
  ];

  dataArray = [
    { band: 'option1', question: '', weight: '' },
    // Add initial rows if needed
  ];

  // Array to hold multiple tables
  tables: Array<any> = [
    {
      dataArray: [{ band: '', question: '', weight: '' }],
    },
  ];

  hideShowFlag: boolean = false;

  // ----------------------------------------Add Or Update Department Colour------------------------------------------------

  saveNineBox() {
    if (this.isLoading) {
      return;
    }
    if (this.isSaveDisabled) {
      this.showToast('Fill all department colors before saving.', 'Error');
      return;
    }

    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear || this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      changedByUserId: this.loggedInUserId,
      departments: this.departmentsColor?.map((dept: any) => ({
        id: dept?.id || null, // Ensure ID is included if present
        departmentName: dept?.departmentName,
        departmentColor: dept?.departmentColor,
      })),
    };
    this.isLoading = true;
    this.httpService
      .callPostService(`${this.config.addOrUpdateBox}`, payload)
      .subscribe({
        next: async (result: any) => {
          this.getAllBoxbyCompany(); // Refresh Data After Save

          const isUpdate = this.departmentsColor?.some((elm: any) => elm.id);
          let message = isUpdate
            ? 'Department colors updated successfully'
            : 'Department colors added successfully';

          this.openDialog(
            message,
            'OK',
            this.buttonColorName,
            false,
            false,
            false
          );
          this.isLoading = false;
        },
        error: async (err: any) => {
          this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          this.isLoading = false;
        },
      });
  }

  // -----------------------------------------Add Or Update Department Colour-----------------------------------------------

  //---------------------------Perf vs Potential Grid-----------------------------------------

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    // Use a regex to check if the value is a valid number or float
    const isValid = /^[0-9]*\.?[0-9]*$/.test(value);

    if (!isValid) {
      // If the input is not valid, you can clear the input or show an error message
      inputElement.value = value.replace(/[^0-9.]/g, '');
    }
  }

  onMaxRangeChangeLowMin(element: any, k: number) {
    const minValue = parseFloat(element?.performanceScoreLowMin);
    const maxValue = parseFloat(element?.performanceScoreLowMax);

    // Check if both values are valid numbers
    if (isNaN(minValue) || isNaN(maxValue)) {
      // this.errorMessage[k] = "Please enter valid numbers for both Min and Max values.";
      this.isInValidLowMinMaxRange[k] = true;

      if (this.checkPotentialGridUrl?.length == 0) {
        this.isPotentialGrid[k] = false;
      } else {
        this.isPotentialGrid[k] = true;
      }
      return; // Exit the function if inputs are invalid
    }

    // Compare the values
    if (maxValue > minValue) {
      this.errorMessage[k] = ''; // Clear error message if valid
      this.isInValidLowMinMaxRange[k] = false;
      if (this.checkPotentialGridUrl?.length == 0) {
        this.isPotentialGrid[k] = false;
        this.isPerformanceSaveBtn[k] = false;
      } else {
        this.isPotentialGrid[k] = true;
      }
    } else {
      this.errorMessage[k] = 'Max value should be greater than Min value.'; // Set error message
      this.isInValidLowMinMaxRange[k] = true;
      this.isPotentialGrid[k] = false;
      this.isPerformanceSaveBtn[k] = true;
    }
  }

  onMaxRangeChangeLowMax(element: any, k: number) {
    const minValue = parseFloat(element?.performanceScoreLowMax);
    const maxValue = parseFloat(element?.performanceScoreMediumMax);
    const lowminValue = parseFloat(element?.performanceScoreLowMin);

    // Check if both values are valid numbers
    if (isNaN(minValue) && isNaN(maxValue) && isNaN(lowminValue)) {
      // this.errorMessage[k] = "Please enter valid numbers for both Min and Max values.";
      this.isInValidLowMinMaxRange[k] = true;
      if (this.checkPotentialGridUrl?.length == 0) {
        this.isPotentialGrid[k] = false;
      } else {
        this.isPotentialGrid[k] = true;
      }
      return; // Exit the function if inputs are invalid
    }

    // Compare the values
    if (maxValue > minValue && minValue > lowminValue) {
      this.errorMessage[k] = ''; // Clear error message if valid
      this.isInValidLowMinMaxRange[k] = false;
      if (this.checkPotentialGridUrl?.length == 0) {
        this.isPotentialGrid[k] = false;
        this.isPerformanceSaveBtn[k] = false;
      } else {
        this.isPotentialGrid[k] = true;
      }
    } else {
      this.isPerformanceSaveBtn[k] = false;
      this.errorMessage[k] = '';
      // Set appropriate error message based on the validation failure
      if (maxValue <= minValue) {
        this.errorMessage[k] = 'Max value should be greater than Min value.'; // Set error message
        this.isPerformanceSaveBtn[k] = true;
      } else if (lowminValue > minValue) {
        this.errorMessage[k] = 'Max value should be greater than Min value.'; // Set error message
        this.isPerformanceSaveBtn[k] = true;
      }

      this.isInValidLowMinMaxRange[k] = true;
      this.isPotentialGrid[k] = false;
    }
  }

  onMaxRangeChangeMediumMax(element: any, k: number) {
    const minValue = parseFloat(element?.performanceScoreLowMax);
    const maxValue = parseFloat(element?.performanceScoreMediumMax);
    const maxHighValue = parseFloat(element?.performanceScoreHighMax);

    // Check if all values are valid numbers
    if (isNaN(minValue) || isNaN(maxValue) || isNaN(maxHighValue)) {
      this.isInValidMediumMinMaxRange[k] = true;
      if (this.checkPotentialGridUrl?.length == 0) {
        this.isPotentialGrid[k] = false;
      } else {
        this.isPotentialGrid[k] = true;
      }
      return; // Exit the function if inputs are invalid
    }

    // Compare the values
    if (maxValue > minValue && maxHighValue > maxValue) {
      this.errorMediumMessage[k] = '';
      this.isInValidMediumMinMaxRange[k] = false;
      // this.isPotentialGrid[k] = true;
      if (this.checkPotentialGridUrl?.length == 0) {
        this.isPotentialGrid[k] = false;
        this.isPerformanceSaveBtn[k] = false;
      } else {
        this.isPotentialGrid[k] = true;
      }
    } else {
      // Set appropriate error message based on the validation failure
      if (maxValue <= minValue) {
        this.errorMediumMessage[k] =
          'Medium Max value should be greater than Low Max value.';
      } else if (maxHighValue <= maxValue) {
        this.errorMediumMessage[k] =
          'High Max value should be greater than Medium Max value.';
      }
      this.isInValidMediumMinMaxRange[k] = true;
      this.isPotentialGrid[k] = false;
      this.isPerformanceSaveBtn[k] = true;
    }
  }

  onMaxRangeChangeHighMax(element: any, k: number) {
    const minValue = parseFloat(element?.performanceScoreMediumMax);
    const maxValue = parseFloat(element?.performanceScoreHighMax);

    // Check if both values are valid numbers
    if (isNaN(minValue) || isNaN(maxValue)) {
      this.errorHighMessage[k] =
        'Please enter valid numbers for both Min and Max values.';
      this.isInValidHighMinMaxRange[k] = true;
      this.isPotentialGrid[k] = false;
      return; // Exit the function if inputs are invalid
    }

    // Compare the values
    if (maxValue > minValue) {
      this.errorHighMessage[k] = ''; // Clear error message if valid
      this.isInValidHighMinMaxRange[k] = false;
      if (this.checkPotentialGridUrl?.length == 0) {
        // this.isPotentialGrid[k] = false;
        // this.isPerformanceSaveBtn[k] = false;
        this.isCheckPerformancePotential[k] = false;
      } else {
        //  this.isPotentialGrid[k] = true;
        this.isCheckPerformancePotential[k] = false;
      }
    } else {
      this.errorHighMessage[k] =
        'High Max value should be greater than Medium Max value.'; // Set error message
      this.isInValidHighMinMaxRange[k] = true;
      // this.isPotentialGrid[k] = false;
      // this.isPerformanceSaveBtn[k] = true;
      this.isCheckPerformancePotential[k] = true;
    }
  }

  // For Updating 9 box performance
  editPotentialGrid(data: any, index: number) {
    if (this.isLoading) {
      return; // Prevent multiple API calls
    }

    var PotentialGridData: any = {};

    PotentialGridData.companyId = this.loggedInUserCompanyID;
    PotentialGridData.year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    PotentialGridData.fiscalYear = this.loggedInCompanyFiscalyear;
    PotentialGridData.changedByUserId = this.loggedInUserId;

    if (data.type == 'performance') {
      PotentialGridData.performanceCategory = 'Performance Score';
      PotentialGridData.type = 'performance';
      PotentialGridData.performanceScoreLowMin = data?.performanceScoreLowMin;
      PotentialGridData.performanceScoreLowMax = data?.performanceScoreLowMax;
      PotentialGridData.performanceScoreMediumMax =
        data?.performanceScoreMediumMax;
      PotentialGridData.performanceScoreHighMax = data?.performanceScoreHighMax;
      PotentialGridData.ppId = data?.ppId;
      this.potentialGridUrl = this.config.addUpdarePerformance;

      this.isPerformanceUpdateBtn[index] = true;
      this.isPerformanceSaveBtn[index] = true;
    } else {
      PotentialGridData.potentialCategory = 'Potential Score';
      PotentialGridData.type = 'potential';
      PotentialGridData.potentialId = data?.potentialId;
      PotentialGridData.potentialScoreLowMin = data?.performanceScoreLowMin;
      PotentialGridData.potentialScoreLowMax = data?.performanceScoreLowMax;
      PotentialGridData.potentialScoreMediumMax =
        data?.performanceScoreMediumMax;
      PotentialGridData.potentialScoreHighMax = data?.performanceScoreHighMax;
      PotentialGridData.potentialId = data?.potentialId;
      this.potentialGridUrl = this.config.addUpdarePotential;
      this.isPerformanceUpdateBtn[index] = true;
      this.isPerformanceSaveBtn[index] = true;
      this.editedPerfvsPotential = null;
    }
    this.isLoading = true;

    this.httpService
      .callPostService(`${this.potentialGridUrl}`, PotentialGridData)
      .subscribe({
        next: async (result: any) => {
          this.editedPerfvsPotential = null;

          this.checkPotentialGridUrl = result?.data;
          if (data.type == 'performance') {
            let ppId = result?.data?.ppId;
            this.PerfvsPotentialGrid[0].ppId = ppId;

            this.openDialog(
              result.message,
              'OK',
              this.buttonColorName,
              false,
              false,
              false
            );
          } else {
            let potentialId = result?.data?.potentialId;
            this.PerfvsPotentialGrid[0].potentialId = potentialId;

            this.openDialog(
              result.message,
              'OK',
              this.buttonColorName,
              false,
              false,
              false
            );
          }
          this.isLoading = false;
        },
        error: async (err: any) => {
          this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          this.isLoading = false;
        },
      });
  }

  closePotentialGrid(index: number) {
    this.editedPerfvsPotential = null;
    // this.isPerformanceUpdateBtn[index] = true;
    // this.isPerformanceSaveBtn[index] = false;
    this.getPerfPotential();
    this.getPerfPerformance();
  }
  // fetch records of Potential Data
  getPerfPotential() {
    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;

    this.httpService
      .callGetService(
        this.config.getAllPotentialScore +
          fiscal_year +
          '/' +
          year +
          '/' +
          companyId
      )
      .subscribe((resp: any) => {
        if (resp.status) {
          this.potentialScoreLength = resp?.data?.length;
          if (resp.data.length > 0) {
            this.isPerformanceUpdateBtn[1] = true;
            this.isPerformanceSaveBtn[1] = true;
            let Potential = resp.data[0];
            this.PerfvsPotentialGrid[1].potentialId = Potential?.potentialId;
            this.PerfvsPotentialGrid[1].performanceScoreLowMin =
              Potential?.potentialScoreLowMin;
            this.PerfvsPotentialGrid[1].performanceScoreLowMax =
              Potential?.potentialScoreLowMax;
            this.PerfvsPotentialGrid[1].performanceScoreMediumMax =
              Potential?.potentialScoreMediumMax;
            this.PerfvsPotentialGrid[1].performanceScoreHighMax =
              Potential?.potentialScoreHighMax;
          } else {
            this.isPerformanceUpdateBtn[1] = false;
            this.isPerformanceSaveBtn[1] = false;
            this.PerfvsPotentialGrid[1].potentialId = '';
            this.PerfvsPotentialGrid[1].performanceScoreLowMin = '';
            this.PerfvsPotentialGrid[1].performanceScoreLowMax = '';
            this.PerfvsPotentialGrid[1].performanceScoreMediumMax = '';
            this.PerfvsPotentialGrid[1].performanceScoreHighMax = '';
          }
        }
      });
  }
  // fetch records of Performance Data
  getPerfPerformance() {
    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;
    // this.isCheckPerformancePotential[0] = true;
    this.httpService
      .callGetService(
        this.config.getAllPerformanceScore +
          fiscal_year +
          '/' +
          year +
          '/' +
          companyId
      )
      .subscribe((resp: any) => {
        if (resp.status) {
          this.performanceScoreLength = resp?.data?.length;
          if (resp.data.length > 0) {
            this.isPerformanceUpdateBtn[0] = true;
            this.isPerformanceSaveBtn[0] = true;
            let Performance = resp.data[0];
            this.PerfvsPotentialGrid[0].ppId = Performance.ppId;
            this.PerfvsPotentialGrid[0].performanceScoreLowMin =
              Performance?.performanceScoreLowMin;
            this.PerfvsPotentialGrid[0].performanceScoreLowMax =
              Performance?.performanceScoreLowMax;
            this.PerfvsPotentialGrid[0].performanceScoreMediumMax =
              Performance?.performanceScoreMediumMax;
            this.PerfvsPotentialGrid[0].performanceScoreHighMax =
              Performance?.performanceScoreHighMax;
          } else {
            this.isPerformanceUpdateBtn[0] = false;
            this.isPerformanceSaveBtn[0] = false;
            let Performance = resp.data[0];
            this.PerfvsPotentialGrid[0].ppId = '';
            this.PerfvsPotentialGrid[0].performanceScoreLowMin = '';
            this.PerfvsPotentialGrid[0].performanceScoreLowMax = '';
            this.PerfvsPotentialGrid[0].performanceScoreMediumMax = '';
            this.PerfvsPotentialGrid[0].performanceScoreHighMax = '';
          }
        }
      });
  }

  updatePotentialGrid(data: any, index: number) {
    this.editedPerfvsPotential = index;
    this.isPerformanceUpdateBtn[index] = false;
  }

  //---------------------------End Perf vs Potential Grid-----------------------------------------

  // ------------------------------------------9 Boxes Names----------------------------------------

  // fetch records of Potential Data
  getPositioningList() {
    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;

    this.httpService
      .callGetService(
        this.config.getAllPositioning +
          fiscal_year +
          '/' +
          year +
          '/' +
          companyId
      )
      .subscribe((resp: any) => {
        if (resp.status) {
          const positions = resp?.data;

          this.nineBoxesNames = positions?.length;

          this.positions = this.positions?.map((elm: any) => {
            let matchRecord = positions?.find(
              (record: any) => record?.positioning == elm?.positioning
            );

            return {
              ...elm,
              positioningId: matchRecord ? matchRecord?.positioningId : null,
              name: matchRecord ? matchRecord?.name : null,
            };
          });
        }
      });
  }

  onClickIndividualNames(data: any, index: number) {
    this.editedIndividualScoreId = index;
    Object.keys(this.isInputPositioning)?.forEach((key) => {
      this.isInputPositioning[+key] = true;
      this.isPositioningEditBtn[+key] = true;
      this.isPositioningCheckCloseIcon[+key] = false;
    });

    this.isPositioningEditBtn[index] = false;
    this.isInputPositioning[index] = false;
    this.isPositioningCheckCloseIcon[index] = true;
  }

  onClosePositioning(data: any, index: number) {
    this.getPositioningList();
    this.editedIndividualScoreId = null;
    this.isPositioningEditBtn[index] = true;
    this.isInputPositioning[index] = true;
    this.isPositioningCheckCloseIcon[index] = false;
  }

  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 100 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 100 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000);
    }
  }

  toastShownForQue = false;

  checkMaxLengthForQue(comment: string) {
    if (comment?.length === 255 && !this.toastShownForQue) {
      this.toastShownForQue = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShownForQue = false;
      }, 3000);
    }
  }

  isLoading: boolean = false;

  onClickIndividualScoreEdit(data: any, index: number) {
    if (this.isLoading) {
      return; // Prevent multiple API calls
    }

    if (!data.name) {
      this.toastr.error('Positioning name is required', 'Error');
      // this.showToast('Positioning name is required', 'danger');
      return;
    }

    this.onCheckIconView = true;
    this.isFormDisabled = true;

    data.companyId = this.loggedInUserCompanyID;
    data.year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    data.fiscalYear = this.loggedInCompanyFiscalyear;
    data.changedByUserId = this.loggedInUserId;

    let message = data.positioningId
      ? 'Positioning updated successfully'
      : 'Positioning added successfully';

    this.isLoading = true;
    this.httpService
      .callPostService(`${this.config.addOrUpdatePositioning}`, data)
      .subscribe({
        next: async (result: any) => {
          this.getPositioningList();
          this.toastr.success(message, 'success');
          // this.showToast(message, 'success');

          this.editedIndividualScoreId = null;
          this.isLoading = false;
        },
        error: async (err: any) => {
          this.toastr.error(err.error.message, 'Error');
          // this.showToast(err.error.message, 'danger');
          // this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          this.isLoading = false;
        },
      });
  }

  // ------------------------------------------End Boxes Names----------------------------------------

  // ---------------------------------------Potential Questionnaire Table------------------------------

  // Save Each Questions
  onClickQuestionsScoreEdit(data: any, index: number, tableIndex: number) {
    if (this.isLoading) {
      return;
    }

    data.companyId = this.loggedInUserCompanyID;
    data.year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    data.fiscalYear = this.loggedInCompanyFiscalyear;
    data.userId = this.loggedInUserId;
    this.isLoading = true;
    this.httpService
      .callPostService(`${this.config.addOrUpdateQuestion}`, data)
      .subscribe({
        next: async (result: any) => {
          this.loadNineBoxData();
          this.toastr.success(result.message, 'success');
          // this.showToast(result.message, 'success');
          //  this.openDialog(result.message, 'OK', this.buttonColorName,false, false,false) ;
          this.getAllQuestions();
          if (data?.questionnaireId) {
            this.isQuestionsCheckCloseIcon[tableIndex][index] = false;
            this.isQuestionsEditBtn[tableIndex][index] = true;
            this.isInputQuestions = this.arrQuestionsList?.map(
              (table: any) => table.question?.map(() => true) // Default all inputs as enabled
            );
          } else {
            this.isQuestionsSaveBtn[tableIndex][index] = false;
            this.isQuestionsEditBtn[tableIndex][index] = true;
            this.isInputQuestions[tableIndex][index] = true;
          }
          this.editedScoreId = null;
          // this.getAllQuestions();
          this.isLoading = false;
        },
        error: async (err: any) => {
          this.toastr.error(err.error.message, 'Error');
          // this.showToast(err.error.message, 'danger');

          this.isLoading = false;
        },
      });
  }

  onClickQuestionslNames(data: any, index: number, tableIndex: number) {
    // this.editedScoreId = index;
    this.closeScore = { question: data.question, weightage: data.weightage };
    this.editedScoreId = tableIndex + '-' + index;

    this.isQuestionsEditBtn[tableIndex][index] = false;
    this.isInputQuestions[tableIndex][index] = false;
    this.isQuestionsCheckCloseIcon[tableIndex][index] = true;
  }

  onClosePositioningQuestions(data: any, index: number, tableIndex: number) {
    if (this.closeScore) {
      data.question = this.closeScore.question;
      data.weightage = this.closeScore.weightage;
    }
    this.calculateTotalWeightage(tableIndex);
    this.editedScoreId = null;
    this.isQuestionsCheckCloseIcon[tableIndex][index] = false;
    this.isQuestionsEditBtn[tableIndex][index] = true;
    this.isInputQuestions[tableIndex][index] = true;
  }

  restrictToNumbers(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;
    const allowedChars = /[0-9]$/;

    // Check if key is not a number or already has a decimal point
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
      return;
    }

    // Predict the new value after adding the pressed key
    const newValue = inputElement.value + event.key;

    // Ensure the value does not exceed 100
    if (parseInt(newValue, 10) > 100) {
      event.preventDefault();
    }
  }

  validateWeightage(tableIndex: number, rowIndex: number) {
    const selectedBand = this.arrQuestionsList[tableIndex];

    // Ensure weightage is always a valid number
    selectedBand.question.forEach((q: any) => {
      q.weightage = q.weightage ? parseFloat(q.weightage) || 0 : 0;
    });

    // Calculate total weightage
    const totalWeightage = selectedBand?.question?.reduce(
      (sum: number, q: any) => sum + q?.weightage,
      0
    );

    if (totalWeightage > 100) {
      this.openDialog(
        'Total weightage cannot exceed 100!',
        'OK',
        'red',
        false,
        false,
        false
      );

      this.isQuestionsCheckCloseIcon[tableIndex][rowIndex] = false;
      this.isQuestionsEditBtn[tableIndex][rowIndex] = true;
      this.isInputQuestions[tableIndex][rowIndex] = true;
      this.getAllQuestions();
    }
  }

  addRow(tableIndex: number) {
    const selectedBand = this.arrQuestionsList[tableIndex];

    // Calculate total weightage
    const totalWeightage = selectedBand?.question?.reduce(
      (sum: number, q: any) => sum + (Number(q?.weightage) || 0),
      0
    );

    if (totalWeightage >= 100) {
      this.openDialog(
        'Total weightage cannot exceed 100!',
        'OK',
        'red',
        false,
        false,
        false
      );
      return;
    }

    // Add new question row
    selectedBand?.question?.push({
      questionnaireId: '', // Random ID
      band: selectedBand?.band,
      changedByUserId: null,
      hodScore: null,
      totalScore: null,
      question: '',
      weightage: '', // Default weightage
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear
        ? this.selectedYear
        : this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
    });

    this.arrQuestionsList?.forEach((table: any, tableIndex: number) => {
      if (Array.isArray(table?.question)) {
        table?.question?.forEach((row: any, i: number) => {
          if (row?.question.trim() === '') {
            this.isInputQuestions[tableIndex][i] = false;
            this.isQuestionsSaveBtn[tableIndex][i] = true;
          } else {
            this.isInputQuestions[tableIndex][i] = true; // Enable input when question is not empty
          }
        });
      }
    });
  }

  //===================================== setup =======================================================>

  weightageErrorMessages: string[] = [];

  // Define an object to track errors for each row
  duplicateErrors: { [key: number]: boolean } = {};

  checkDuplicateQuestion(row: any, tableIndex: number, Index: number) {
    let strQuestion = row?.question;
    let strBand = row?.band;

    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;

    this.httpService
      .callGetService(
        this.config.getAllQuestions + fiscal_year + '/' + year + '/' + companyId
      )
      .subscribe((resp: any) => {
        const arrAllQuestions = resp?.data;

        this.forDuplicateCheckarrAllQuestions = this.getListOfBandName?.map(
          (bandItem: any) => {
            let matchedQuestions = arrAllQuestions?.filter(
              (q: any) => q?.band == bandItem?.band
            );
            return {
              ...bandItem,
              // id: matchedQuestions?matchedQuestions.id:null,
              question: matchedQuestions ? matchedQuestions : null,
            };
          }
        );
        // Filter the list to get the same band
        const arrQuestionsListFiltered =
          this.forDuplicateCheckarrAllQuestions?.find(
            (item: any) => item?.band === strBand
          );

        if (arrQuestionsListFiltered) {
          // Check if the question already exists in the selected band
          const isDuplicate = arrQuestionsListFiltered?.question?.some(
            (q: any) => q?.question === strQuestion
          );

          if (isDuplicate) {
            // this.editedScoreId = Index;
            this.duplicateErrors[tableIndex] = true;
          }
        }
      });

    this.duplicateErrors[tableIndex] = false;

    // this.editedScoreId = null;
  }

  limitWeightage(row: any, tableIndex: number) {
    if (row.weightage > 100) {
      row.weightage = 100; // Max value ko 100 restrict karna
      return;
    }
    this.calculateTotalWeightage(tableIndex);
  }

  calculateTotalWeightage(tableIndex: number) {
    if (
      !this.arrQuestionsList[tableIndex] ||
      !this.arrQuestionsList[tableIndex].question
    ) {
      this.totalWeightage[tableIndex] = 0;
      return;
    }

    this.totalWeightage[tableIndex] = this.arrQuestionsList[tableIndex].question
      .map((q: { weightage: any }) => Number(q?.weightage) || 0)
      .reduce((sum: any, value: any) => sum + value, 0);

    if (this.totalWeightage[tableIndex] !== 100) {
      this.weightageErrorMessages[tableIndex] = 'Total weightage should be 100';
    } else {
      this.weightageErrorMessages[tableIndex] = '';
    }
    this.saveDataToStorage();
  }

  saveDataToStorage() {
    localStorage.setItem(
      'arrQuestionsList',
      JSON.stringify(this.arrQuestionsList)
    );
    localStorage.setItem('totalWeightage', JSON.stringify(this.totalWeightage));
  }

  loadDataFromStorage() {
    const storedQuestions = localStorage.getItem('arrQuestionsList');
    const storedWeightage = localStorage.getItem('totalWeightage');

    if (storedQuestions) {
      this.arrQuestionsList = JSON.parse(storedQuestions);
    }

    if (storedWeightage) {
      this.totalWeightage = JSON.parse(storedWeightage);
    }
  }

  recalculateTotalWeightage() {
    this.arrQuestionsList.forEach((_: any, index: number) =>
      this.calculateTotalWeightage(index)
    );
  }

  deleteBand(tableIndex: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete these band Types?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadNineBoxData();
        this.arrQuestionsList = this.arrQuestionsList?.filter(
          (band: any) => band?.band !== tableIndex
        );

        this.getListOfBandName = this.getListOfBandName?.filter(
          (band: any) => band?.band !== tableIndex
        );

        this.httpService
          .callDeleteService(
            `${this.config.deleteBandsninebox + tableIndex}/${
              this.loggedInCompanyFiscalyear
            }/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`
          )
          .subscribe(
            () => {
              const successdialogRef = this.dialog.open(
                ConfirmationPopupComponent,
                {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'Questions  deleted successfully.',
                    btn2: 'OK',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false,
                  },
                }
              );
              this.getAllQuestions();
              successdialogRef.afterClosed().subscribe(() => {});
            },
            (error: any) => {
              // Handle error case

              // Optional: Show error dialog
              const successdialogRef = this.dialog.open(
                ConfirmationPopupComponent,
                {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'band successfully deleted.',
                    btn2: 'OK',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false,
                  },
                }
              );
            }
          );
      }
    });
  }

  // Add New Band Table
  addNewBand() {
    const newBandName = `Band ${this.arrQuestionsList.length + 1}`;

    const bandExistsInList = this.getListOfBandName?.some(
      (band: any) => band?.band === newBandName
    );

    const bandExistsInUpdatedList = this.arrQuestionsList?.some(
      (band: any) => band?.band === newBandName
    );

    if (!bandExistsInList) {
      this.showToast(
        'This band does not exist in the available band list!',
        'Error'
      );
    } else if (bandExistsInUpdatedList) {
      alert('Band already added!');
    } else {
      this.arrQuestionsList?.push({
        id: newBandName,
        band: newBandName,
        question: [],
      });
    }
  }

  // Get Available Bands
  getAvailableBands(tableIndex: number) {
    const selectedBands =
      this.tables[tableIndex]?.dataArray?.map((row: any) => row.band) || [];
    return this.getListOfBandName?.filter(
      (option: any) => !selectedBands?.includes(option.id)
    );
  }
  getBandsByCompany() {
    this.httpService
      .callGetService(
        this.config.getBandsByCompany + this.loggedInUserCompanyID
      )
      .subscribe((data: any) => {
        this.getListOfBandName = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            band: ele,
            question: '',
            weightage: '',
          };
          this.getListOfBandName?.push(obj);
        });
        this.getListOfBandName = this.getListOfBandName?.sort(
          (a: { band: any }, b: { band: any }) => a.band.localeCompare(b.band)
        );

        this.getAllQuestions();
      });
  }

  arrQuestionsList: any = [];

  getAllQuestions() {
    let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;

    this.httpService
      .callGetService(
        this.config.getAllQuestions + fiscal_year + '/' + year + '/' + companyId
      )
      .subscribe((resp: any) => {
        const arrAllQuestions = resp?.data;

        this.arrQuestionsList = this.getListOfBandName?.map((bandItem: any) => {
          let matchedQuestions = arrAllQuestions?.filter(
            (q: any) => q?.band == bandItem?.band
          );
          return {
            ...bandItem,
            // id: matchedQuestions?matchedQuestions.id:null,
            question: matchedQuestions ? matchedQuestions : null,
          };
        });

        this.forDuplicateCheckarrAllQuestions = this.getListOfBandName?.map(
          (bandItem: any) => {
            let matchedQuestions = arrAllQuestions?.filter(
              (q: any) => q?.band == bandItem?.band
            );
            return {
              ...bandItem,
              // id: matchedQuestions?matchedQuestions.id:null,
              question: matchedQuestions ? matchedQuestions : null,
            };
          }
        );

        //  calculateTotalWeightage
        this.arrQuestionsList?.forEach((item: any, index: number) => {
          this.calculateTotalWeightage(index);
          if (item.question?.length === 0) {
          } else if (Array.isArray(item.question)) {
            item.question?.forEach((row: any, key: number) => {});
          }
        });

        this.isInputQuestions = this.arrQuestionsList?.map(
          (table: any) => table.question?.map(() => true) // Default all inputs as enabled
        );
        this.isQuestionsEditBtn = this.arrQuestionsList?.map(
          (table: any) => table.question?.map(() => true) // Default all inputs as enabled
        );
        this.isQuestionsCheckCloseIcon = this.arrQuestionsList?.map(
          (table: any) => table.question?.map(() => false) // Default all inputs as enabled
        );
        this.isQuestionsSaveBtn = this.arrQuestionsList?.map(
          (table: any) => table.question?.map(() => false) // Default all inputs as enabled
        );
      });
  }

  getAllQuestionsForReport() {
    this.httpService
      .callGetService(this.config.getEmployeeById + this.loggedInUserId)
      .subscribe((data: any) => {
        let loggedInUserBand = data?.data?.band;

        let companyId = this.loggedInUserCompanyID;
        let year = this.selectedYear
          ? this.selectedYear
          : this.selectedYearForCompetency;
        let fiscal_year = this.loggedInCompanyFiscalyear;

        this.httpService
          .callGetService(
            this.config.getAllQuestions +
              fiscal_year +
              '/' +
              year +
              '/' +
              companyId
          )
          .subscribe((resp: any) => {
            const arrAllQuestions = resp?.data;

            const bandMatched = arrAllQuestions?.filter(
              (ques: any) => ques?.band == loggedInUserBand
            );
            this.bandNotFound = bandMatched?.length > 0 ? true : false;
          });
      });
  }

  editPositioning(data: any) {
    this.isPositioning = true;
    this.isPositioningFormDisabled = true;

    data.companyId = this.loggedInUserCompanyID;
    data.year = this.selectedYear
      ? this.selectedYear
      : this.selectedYearForCompetency;
    data.fiscalYear = this.loggedInCompanyFiscalyear;
    data.changedByUserId = this.loggedInUserId;

    this.httpService
      .callPostService(`${this.config.addOrUpdateQuestion}`, data)
      .subscribe({
        next: async (result: any) => {
          this.openDialog(
            result.message,
            'OK',
            this.buttonColorName,
            false,
            false,
            false
          );
        },
        error: async (err: any) => {
          this.openDialog(err.error.message, 'OK', 'red', false, false, false);
        },
      });
  }

  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top',
    });
    await toast.present();
  }

  removeRow(index: number) {
    this.dataArray.splice(index, 1);
    this.hideShowFlag = false;
  }

  onCheckIconView = false;
  isFormDisabled = false;

  // ---------------------------------------------------9 Box Master----------------------------------------------------------

  selectDepartname: any = [];

  NineBoxMasterDepartmentChange(event: any) {
    let objNineBoxMaster = this.objNineBoxQuestionMaster;
    this.selectDepartname = event;

    this.selectedDepartmentsNineBoxMaster = [];
    const departmentName = {
      id: event,
      name: event,
    };

    this.selectedDepartmentsNineBoxMaster.push(departmentName);
    // const nineboxData = this.arrNineBoxMasterData.filter((item: any) => item.department == this.selectDepartname?.trim());
    const nineboxData = objNineBoxMaster.filter(
      (item: any) =>
        item.department ==
        (typeof this.selectDepartname === 'string'
          ? this.selectDepartname.trim()
          : '')
    );

    this.findNineBoxMasterData(); // On change of department, findNineBoxMasterData is called

    if (this.loggedInUserRole == 'HOD') {
      // nineboxData?.map((item: any) => {
      //   if (this.arrHODByUserList?.some((hod: any) => hod?.userId == item?.userId)) {
      //     objNineBoxMaster?.push(item);
      //   }
      // });

      this.questionsArray1 = nineboxData;
    } else {
      objNineBoxMaster = nineboxData;
      this.questionsArray1 = objNineBoxMaster;
    }
  }

  // -------------------Employees couunt in dropdown-----------------------

  addScoreCountsToDepartments() {
    const deptMap: { [key: string]: { total: number; scored: number } } = {};

    let nineBoxMasterData = this.arrNineBoxMasterData;

    const selectedDeptName = this.selectDepartname;
    //  HOD data filter
    if (this.loggedInUserRole === 'HOD') {
      nineBoxMasterData = this.arrNineBoxMasterData.filter((item: any) =>
        this.arrHODByUserList.some((hod: any) => hod.userId == item.userId)
      );
    }

    // Count logic
    nineBoxMasterData.forEach((employee: any) => {
      const dept = employee.department;

      if (!deptMap[dept]) {
        deptMap[dept] = { total: 0, scored: 0 };
      }

      deptMap[dept].total += 1;

      // if (employee.finalScore !== null && employee.finalScore !== undefined) {
      //   deptMap[dept].scored += 1;
      // }
      const hasHodScore = employee.questions?.every(
        (q: any) => q.hodScore !== null && q.hodScore !== undefined
      );

      if (hasHodScore) {
        deptMap[dept].scored += 1;
      }
    });

    // Add the count to each department in the dropdown
    this.frequencyDeptName = nineBoxMasterData.map((dept: any) => {
      const deptName = dept.department;
      const counts = deptMap[deptName] || { total: 0, scored: 0 };

      return {
        id: deptName,
        total: counts.total,
        scored: counts.scored,
      };
    });

    this.frequencyDeptName = this.frequencyDeptName.filter(
      (item: any, index: any, self: any) =>
        index === self.findIndex((t: any) => t.id === item.id)
    );
  }

  getfreezeEmployees() {
    const apiUrl = `${this.config.getfreezeEmployees}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        this.forHodfreezeEmployees = response?.data;
      },
      error: (err: any) => {},
    });
  }

  loadNineBoxData() {
    const apiUrl = `${this.config.getemployeeDetails}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        if (response) {
          let nineboxData = response.data;
          this.getemployeeDetails = nineboxData;
          nineboxData.forEach((item: any) => {
            if (this.loggedInUserRole == 'HOD') {
              if (
                this.forHodfreezeEmployees?.some(
                  (hod: any) => hod?.userId == item?.userId
                )
              ) {
                item.freeze = true;
              } else {
                item.freeze = false;
              }
            } else {
              item.freeze = false;
            }
          });

          if (this.loggedInUserRole === 'HOD') {
            nineboxData = nineboxData.filter((emp: any) =>
              this.arrHODByUserList?.some(
                (hod: any) => hod.userId === emp.userId
              )
            );
          }
          const tempnineboxData = nineboxData; // suppose this is an array of employee objects

          const questionsArray1: any[] = [];

          (tempnineboxData || []).forEach((item: any) => {
            const questionsArray = (item.questions || []).map((q: any) => ({
              ...q,
              userId: item.userId,
              employeeId: item.employeeId,
              fullName: `${item.firstName} ${item.lastName}`,
              department: item.department,
              band: item.band,
              kpiScore: item.kpiScore,
              year: item.year,
              fiscalYear: item.fiscalYear,
              finalScore: item.finalScore,
              freeze: item.freeze,
            }));

            // Push all question objects into one flat array
            questionsArray1.push(...questionsArray);
          });
          this.handleIncomingDataFromApi(questionsArray1);

          this.arrNineBoxMasterData = nineboxData;
          this.addScoreCountsToDepartments();

          setTimeout(() => {
            if (this.selectDepartname.length > 0) {
              this.NineBoxMasterDepartmentChange(this.selectDepartname);
            }
          }, 0);

          // this.nineboxData = nineboxData?.filter((item:any)=>item?.department == this.selectDepartname?.trim());
          this.nineboxData = nineboxData?.filter(
            (item: any) =>
              item?.department ===
              (typeof this.selectDepartname === 'string'
                ? this.selectDepartname.trim()
                : this.selectDepartname)
          );
        } else {
          console.warn('No data received');
        }
      },
      error: (err: any) => {},
    });
  }

  trackByFn(index: number, item: any): number {
    return item?.id;
  }

  trackByQuestion(index: number, question: any): number {
    return question?.questionnaireId;
  }

  // Validate Total Weightage
  isWeightageValid(item: any): boolean {
    const totalWeightage = item?.questions?.reduce(
      (sum: number, que: any) => sum + (parseInt(que?.weightage) || 0),
      0
    );
    return totalWeightage === 100;
  }

  // Check if ALL employees have valid weightage
  isAllWeightageValid(): boolean {
    return this.nineboxData?.every((item: any) => this?.isWeightageValid(item));
  }

  isAllBandsEmpty(): boolean {
    return this.questionsArray1.length === 0;
  }

  // ==================== Score By HOD ==============================================

  debounceTimer: any;

  onHodScoreChange(item: any, question: any) {
  const trimmedScore = question.hodScore?.toString().trim();
  if (trimmedScore === '') {
    question.totalScore = 0;
  } else {
    const hod = Number(trimmedScore) || 0;
    const weight = Number(question.weightage) || 0;
    question.totalScore = +(hod * (weight / 100));
  }

  // recompute finalScore for that item (client-side)
  item.finalScore = (item.questions || []).reduce((s: number, q: any) => {
    return s + (Number(q.totalScore) || 0);
  }, 0);

  clearTimeout(this.debounceTimer);
  this.debounceTimer = setTimeout(() => {
    this.updateHodScore(item, question);
  }, 500);
}


  updateHodScore(item: any, question: any) {
    const payload = {
      userId: parseInt(item?.userId),
      questionnaireId: question?.questionnaireId,
      // hodScore: (question?.hodScore) ? parseInt(question?.hodScore) : ''
      hodScore:
        question?.hodScore?.toString().trim() === ''
          ? null
          : parseInt(question?.hodScore),
    };

    this.httpService
      .callPutService(`${this.config.updatehodscore}`, payload)
      .subscribe(
        (data: any) => {
          if (data) {
            console.log('HOD Score updated successfully',data);
            this.loadNineBoxData();
            // this.getPerformanceVsPotential();
            setTimeout(() => {
              this.getPerformanceVsPotential();
            }, 200);
            this.dumpreport();
            this.getEmployeeTrends();
          }
        },
        (error: any) => {}
      );
  }

  getDashBoardDeptWiseNineBoxMaster() {
    this.findNineBoxMasterData();
  }

  getDashBoardDeptWiseonDeSelectNineBoxMaster() {
    this.onDeSelectAllDeptWiseDashboardNineBoxMaster();
  }

  selectAllDeptWiseDashboardNineBoxMaster(event: any) {
    this.selectedDepartmentsNineBoxMaster = event;
    this.findNineBoxMasterData();
  }

  onDeSelectAllDeptWiseDashboardNineBoxMaster() {
    this.selectedDepartmentsNineBoxMaster = [];
    this.findNineBoxMasterData();
  }

  findNineBoxMasterData() {
    // this.arrNineBoxMasterData
    let filteredData: any = {}; // Use an object to group employees by category
    let bandData: any = [];
    let employeeData: any = [];

    let filteredData1: any = {}; // Use an object to group employees by category
    let bandData1: any = [];
    let employeeData1: any = [];

    if (this.arrNineBoxMasterFor9BoxData.length == 0) {
      this.performanceDta = [
        {
          count: '0',
          category: 'Low performance & low potential',
          cssClass: 'enigma',
        },
        {
          count: '0',
          category: 'High performance & high potential',
          cssClass: 'growth-employee',
        },
        {
          count: '0',
          category: 'High performance & medium potential',
          cssClass: 'future-leader',
        },
        {
          count: '0',
          category: 'Low performance & medium potential',
          cssClass: 'effective',
        },
        {
          count: '0',
          category: 'Medium performance & high potential',
          cssClass: 'core-employee',
        },
        {
          count: '0',
          category: 'Low performance & high potential',
          cssClass: 'high-impact-performer',
        },
        {
          count: '0',
          category: 'Medium performance & low potential',
          cssClass: 'under-performer',
        },
        {
          count: '0',
          category: 'Medium performance & medium potential',
          cssClass: 'dilemma',
        },
        {
          count: '0',
          category: 'High performance & low potential',
          cssClass: 'trusted-professional',
        },
      ];
      return;
    }

    this.arrNineBoxMasterFor9BoxData?.forEach((record: any) => {
      // Ensure the category exists in filteredData (default structure)
      if (!filteredData[record?.category]) {
        filteredData[record?.category] = {
          category: record?.category,
          count: 0,
          employeeDetails: [],
          cssClass: record?.cssClass,
        };
      }
      //for default call
      if (!filteredData1[record?.category]) {
        filteredData1[record?.category] = {
          category: record?.category,
          count: 0,
          employeeDetails: [],
          cssClass: record?.cssClass,
        };
      }

      if (record?.employeeDetails && Array?.isArray(record?.employeeDetails)) {
        record?.employeeDetails?.forEach((employee: any) => {
          //for default call
          if (!bandData1[employee?.band]) {
            bandData1?.push(employee?.band);
          }

          if (!employeeData1[employee]) {
            employeeData1?.push(employee);
          }

          filteredData1[record?.category].employeeDetails?.push(employee);
          filteredData1[record?.category].count++; // Increment count

          if (
            this.selectedDepartmentsNineBoxMaster?.some(
              (dept: any) => dept?.id == employee?.department
            )
          ) {
            // Push the employee details into the already initialized category
            if (!bandData[employee?.band]) {
              bandData?.push(employee?.band);
            }

            if (this.loggedInUserRole == 'HOD') {
              if (
                this.arrHODByUserList.some(
                  (hod: any) => hod?.userId == employee?.userId
                )
              ) {
                if (!employeeData[employee]) {
                  employeeData?.push(employee);
                }

                filteredData[record?.category].employeeDetails?.push(employee);
                filteredData[record?.category].count++; // Increment count
              }
            } else {
              if (!employeeData[employee]) {
                employeeData?.push(employee);
              }

              filteredData[record?.category].employeeDetails?.push(employee);
              filteredData[record?.category].count++; // Increment count
            }
          }
        });
      }
    });

    this.performanceDta = Object?.values(filteredData);

    this.arrPerformanceVsPotentialReport = Object?.values(filteredData1);

    // this.findNineBoxMasterData();
  }

  getYearSetupForNineBox(selectedYear: any) {
    this.selectedYearForCompetency = selectedYear;

    this.getPerformanceVsPotential();
  }

  getPerformanceVsPotential() {
    //this.loader.simpleLoader();
    const colorClasses = [
      'enigma',
      'growth-employee',
      'future-leader',
      'dilemma',
      'core-employee',
      'high-impact-performer',
      'under-performer',
      'effective',
      'trusted-professional',
    ];

    let positions = [
      'Low performance high potential',
      'Medium performance high potential',
      'High performance high potential',
      'Low performance medium potential',
      'Medium performance medium potential',
      'High performance medium potential',
      'Low performance low potential',
      'Medium performance low potential',
      'High performance low potential',
    ];

    const apiUrl = `${this.config.getAllPerformancePotential}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        this.performancePotentialLength = response?.data?.length;

        if (response && response.data && response?.data?.length > 0) {
          const arrDashboardData = response?.data;
          arrDashboardData?.forEach((item: any) => {
            // Remove duplicate employees based on userId
            item.employeeDetails = item.employeeDetails?.filter(
              (employee: any, index: any, self: any) =>
                index ===
                self?.findIndex((e: any) => e?.userId === employee.userId)
            );
          });

          arrDashboardData?.sort((a: any, b: any) => {
            return positions?.indexOf(a?.label) - positions?.indexOf(b?.label);
          });

          let performanceDta = arrDashboardData?.map(
            (cell: any, index: number) => ({
              ...cell,
              cssClass: colorClasses[index] || 'default-cell', // Assigns a class to each cell
            })
          );

          this.arrNineBoxMasterFor9BoxData = performanceDta;

          // this.findNineBoxMasterData();
          if (
            this.loggedInUserRole == 'Employee' ||
            this.loggedInUserRole == 'Manager' ||
            this.loggedInUserRole == 'MD'
          ) {
            this.forReportPerformanceVsPotential();
          }
        } else {
          this.arrNineBoxMasterFor9BoxData = [];
          this.arrPerformanceVsPotentialReport = [];
          this.findNineBoxMasterData();
        }

        // this.loader.dismissLoader();
        // this.PerformanceVsPotentialReport();
        if (this.loggedInUserRole != 'Employee') {
          this.forReportPerformanceVsPotential();
        }
      },
      error: (err: any) => {},
    });
  }

  // Function to return color class based on the category
  getCellColors(category: string) {
    const colorMapping: { [key: string]: string } = {
      Enigma: '#F4D03F',
      'Growth Employee': '#2ECC71',
      'Future Leader': '#27AE60',
      Dilemma: '#E67E22',
      'Core Employee': '#F39C12',
      'High Impact Performer': '#76D7C4',
      'Under Performer': '#E74C3C',
      Effective: '#D35400',
      'Trusted Professional': '#F1C40F',
    };

    return { backgroundColor: colorMapping[category] || '#D5D8DC' }; // Default grey color
  }

  openEmployeeTooltip(cell: any): void {
    this.dialog?.open(EmployeeTooltipDialogComponent, {
      data: {
        employees: cell?.employeeDetails || [],
        departmentsColor: this?.departmentsColor || [],
      },
      panelClass: 'phi_mdc_dialog__container_100',
      width: '75%',

      position: {
        top: '5%',
        left: '20%',
      },
    });
  }

  originalRawData: any[] = []; // store raw data from API
  // call this after fetching API
  objNineBoxQuestionMaster: any = [];
  handleIncomingDataFromApi(apiData: any[]) {
    this.originalRawData = apiData || [];
    this.objNineBoxQuestionMaster = this.prepareNineBoxData(
      this.originalRawData
    );

    if (this.gridApi) {
      // this.gridApi.setRowData(this.questionsArray1);
      this.gridApi.redrawRows();
    }
  }

  // prepare data: mark isFirst and rowSpan for rows that share band+fullName+finalScore
  prepareNineBoxData(data: any[]): any[] {
    const map = new Map<string, any[]>();

    data.forEach((item) => {
      const band = (item.band ?? '').toString().trim();
      const name = (item.fullName ?? '').toString().trim();
      // normalize finalScore so undefined/null are consistent strings
      const finalScoreKey =
        item.finalScore === null || item.finalScore === undefined
          ? '__NULL__'
          : String(item.finalScore).trim();

      const key = `${band}:::${name}:::${finalScoreKey}`;

      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(item);
    });

    const out: any[] = [];
    // preserve original order within each group if needed
    map.forEach((group) => {
      group.forEach((row, idx) => {
        row.isFirst = idx === 0;
        row.rowSpan = group.length;
        out.push(row);
      });
    });

    return out;
  }

  // ---------------------------------------------------End 9 Box Master----------------------------------------------------------

  // --------------------------------------------------------Report------------------------------------------------------------------------

  fetchHODByUserList() {
    let apiUrl = `${this.config.fetchHODByUserList}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${this.selectedYearForCompetency}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(apiUrl).subscribe((resp: any) => {
      const arrHODByUserList = resp?.data?.data?.filter(
        (emp: any) => emp?.userId != this.loggedInUserId
      );
      this.arrHODByUserList = arrHODByUserList;

      arrHODByUserList?.map((emp: any) => {
        this.arrUserIds?.push(emp?.userId);
      });
    });
  }

  // selectedDepartments: string[] = [];

  // dropdownSettings: IDropdownSettings = {};
  getDepartmentsList!: any[];
  dropdownSettings = {
    singleSelection: false, // or true based on your requirement
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };

  getDepartmentData() {
    const apiUrl = `${this.config.getemployeeDetails}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        let employeeData = response?.data || [];

        if (
          this.loggedInUserRole == 'Employee' ||
          this.loggedInUserRole == 'Manager' ||
          this.loggedInUserRole == 'MD'
        ) {
          this.getDepartmentsList =
            this.selectedPerformanceDepartments =
            this.selectedDepartments =
              [
                {
                  id: this.loggedInUserDepartment,
                  name: this.loggedInUserDepartment,
                },
              ];

          employeeData = employeeData.filter(
            (emp: any) => emp.department === this.loggedInUserDepartment
          );
        } else if (this.loggedInUserRole === 'HOD') {
          employeeData = employeeData.filter((emp: any) =>
            this.arrHODByUserList.some((hod: any) => hod.userId === emp.userId)
          );
          employeeData = employeeData.filter(
            (emp: any) => emp.department !== this.loggedInUserDepartment
          );
        }

        this.selectedPerformanceDepartments =
          this.selectedDepartments =
          this.selectedDepartmentEmployeeTrends =
          this.selectedDepartmentsNineBoxMaster =
          this.allDepartmentsList =
            [];
        this.allDepartmentsList = [];
        const departmentCounts: any = {};

        employeeData.forEach((emp: any) => {
          const dept = emp.department;

          if (!departmentCounts[dept]) {
            departmentCounts[dept] = { total: 0, scored: 0 };
          }

          departmentCounts[dept].total += 1;
          if (emp.finalScore !== null && emp.finalScore !== undefined) {
            departmentCounts[dept].scored += 1;
          }
        });

        this.getDepartmentsList = Object.keys(departmentCounts)
          .map((dept) => {
            const counts = departmentCounts[dept];
            return {
              id: dept,
              // name: `${dept} (${counts.scored}/${counts.total})`
              name:
                this.loggedInUserRole === 'Employee' ||
                this.loggedInUserRole === 'Manager' ||
                this.loggedInUserRole == 'MD'
                  ? dept
                  : `${dept} (${counts.scored}/${counts.total})`,
            };
          })
          .sort((a, b) => a.name.localeCompare(b.name));

        if (this.getDepartmentsList && this.getDepartmentsList.length > 0) {
          // this.selectedPerformanceDepartments.push(this.getDepartmentsList[0]);
          this.selectedPerformanceDepartments = [this.getDepartmentsList[0]];
          // this.selectedDepartments.push(this.getDepartmentsList[0]);
          this.selectedDepartments = [this.getDepartmentsList[0]];
          // this.selectedDepartmentEmployeeTrends.push(this.getDepartmentsList[0]);
          this.flattenDumpReportData();
          this.selectedDepartmentEmployeeTrends = [this.getDepartmentsList[0]];
          this.selectedDepartmentsNineBoxMaster.push(
            this.getDepartmentsList[0]
          );
          this.selectedDepartmentsNineBoxMaster = [this.getDepartmentsList[0]];
          this.allDepartmentsList.push(this.getDepartmentsList);
        } else {
          console.warn('No departments found.');
        }

        this.dumpreport();
        this.getEmployeeTrends();

        this.getPerformanceVsPotential();
      },
      error: (err: any) => {},
    });
  }

  //==========================Dump report==================================================
  dumpreport() {
    const apiUrl = `${this.config.getAllEmployeeDumpReports}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        if (response && response?.data) {
          const arrAllDumpReport = response?.data;

          // Group data by department
          let groupedData = arrAllDumpReport?.reduce((acc: any, item: any) => {
            if (!acc[item?.department]) {
              acc[item?.department] = [];
            }
            acc[item?.department]?.push(item);
            return acc;
          }, {});

          // Filter grouped data without using Object.fromEntries
          let filteredData: any = [];

          Object?.entries(groupedData)?.forEach(([key, value]: any) => {
            if (
              this.selectedDepartments?.some((dept: any) => dept?.id === key)
            ) {
              if (this.loggedInUserRole === 'HOD') {
                const filteredValues = value?.filter((data: any) =>
                  this.arrHODByUserList?.some(
                    (hod: any) => hod?.userId === data?.userId
                  )
                );

                if (filteredValues.length > 0) {
                  filteredData[key] = filteredValues; // Store filtered results
                }
              } else if (
                this.loggedInUserRole == 'Employee' ||
                this.loggedInUserRole == 'Manager' ||
                this.loggedInUserRole == 'MD'
              ) {
                const filteredValues = value?.filter(
                  (data: any) => this.loggedInUserId == data?.userId
                );

                if (filteredValues?.length > 0) {
                  filteredData[key] = filteredValues; // Store filtered results
                }
              } else {
                filteredData[key] = value; // Store full data if not HOD
              }
            }
          });

          this.groupedData = filteredData;
          this.arrDumpReport = groupedData;
          // Extract department names for looping in HTML
          this.departments = Object?.keys(this.groupedData);
        } else {
          console.warn('No data received');
        }
      },
      error: (err: any) => {},
    });
  }

  // For Dump Report
  getDashBoardDeptWise() {
    let filteredData: any = {};

    // STEP 1: FILTER DEPARTMENT DATA (your original logic)
    Object.entries(this.arrDumpReport || {}).forEach(
      ([key, value]: [string, any[]]) => {
        if (this.selectedDepartments?.some((dept: any) => dept.id === key)) {
          // HOD Filter
          if (this.loggedInUserRole === 'HOD') {
            const filteredValues = value.filter((data: any) =>
              this.arrHODByUserList?.some(
                (hod: any) => hod.userId === data.userId
              )
            );
            if (filteredValues.length > 0) {
              filteredData[key] = filteredValues;
            }
          }

          // Employee / Manager / MD Filter
          else if (
            this.loggedInUserRole === 'Employee' ||
            this.loggedInUserRole === 'Manager' ||
            this.loggedInUserRole === 'MD'
          ) {
            const filteredValues = value.filter(
              (data: any) => data.userId === this.loggedInUserId
            );
            if (filteredValues.length > 0) {
              filteredData[key] = filteredValues;
            }
          }

          // Admin / HR / Super Admin → no filtering
          else {
            filteredData[key] = value;
          }
        }
      }
    );

    // SAVE FILTERED GROUPED DATA
    this.groupedData = filteredData;
    this.selectedCountForDumpreportDepartment = this.selectedDepartments.length;
    this.departments = Object.keys(this.groupedData);

    // STEP 2: FLATTEN DATA FOR AG GRID
    this.flattenDumpReportData();
  }

  getDashBoardDeptWiseonDeSelect() {
    this.selectedCountForDumpreportDepartment = this.selectedDepartments.length;
    this.getDashBoardDeptWise();
  }

  selectAllDeptWiseDashboard() {
    this.selectedCountForDumpreportDepartment = this.selectedDepartments.length;
    // this.groupedData = this.arrDumpReport;
    this.selectedDepartments = this.getDepartmentsList;

    this.getDashBoardDeptWise();
  }

  onDeSelectAllDeptWiseDashboard() {
    this.selectedCountForDumpreportDepartment = 0;
    this.departments = [];
    this.groupedData = {};
    // this.selectAllDeptWiseDashboard();
  }

  selectedCountForDumpreportDepartment: number = 0;
  selectedperformancesBands: any[] = [];
  selectedCountForPerformanceVsPotentialEmployee: any = [];

  updateSelectedCountForDumpreport() {
    this.selectedCountForDumpreportDepartment =
      this.selectedDepartments?.length;
    this.selectedCountForPerformanceVsPotentialBand =
      this.selectedperformancesBands?.length;
    this.selectedCountForPerformanceVsPotentialEmployee =
      this.selectedPerformanceEmployee?.length;
  }

  // Ensure selectedDepartments contains only department names (strings)
  onDepartmentSelect(event: any) {}

  // ****************Performance vs Potential Report*********************

  // For Performance vs Potential
  getSelectedPerformanceVsPotential(event: any) {
    // ---------------------
    this.selectedPerformanceEmployee = event;
    this.forReportPerformanceVsPotential();
  }

  getDeSelectedPerformanceVsPotential() {
    if (this.selectedPerformanceDepartments.length == 0) {
      this.emptyReportPerformanceVsPotential();
    } else {
      this.selectedperformancesBands = [];
      this.selectedPerformanceEmployee = [];
      this.forReportPerformanceVsPotential(); //Performance vs Potential
    }
    // this.selectedPerformanceDepartments = [];
  }

  selectAllPerformanceVsPotential() {
    this.selectedPerformanceDepartments = this.allDepartmentsList[0];
    this.selectedperformancesBands = [];
    this.selectedPerformanceEmployee = [];
    this.forReportPerformanceVsPotential();
  }

  onDeSelectAllPerformanceVsPotential() {
    this.selectedPerformanceDepartments = [];
    this.selectedPerformanceEmployee = [];
    this.selectedperformancesBands = [];
    // this.arrPerformanceVsPotential = [];
    this.emptyReportPerformanceVsPotential();
  }

  selectedCountForPerformanceVsPotentialBand: number = 0;
  // performance band dropdown

  onPerformanceBandSelect() {
    this.selectedCountForPerformanceVsPotentialBand =
      this.selectedperformancesBands?.length;
    this.forReportPerformanceVsPotential();
  }

  onperformanceBandDeSelect() {
    this.selectedPerformanceEmployee = [];
    this.selectedCountForPerformanceVsPotentialBand =
      this.selectedperformancesBands?.length;
    this.forReportPerformanceVsPotential();
  }

  onSelectAllPerformanceBands(event: any) {
    this.selectedCountForPerformanceVsPotentialBand =
      this.selectedperformancesBands?.length;
    this.selectedperformancesBands = event;

    this.forReportPerformanceVsPotential();
  }

  onDeSelectAllPerformanceBands() {
    this.selectedCountForPerformanceVsPotentialBand = 0;
    this.selectedperformancesBands = [];
    this.forReportPerformanceVsPotential();
  }

  arrEmployeesReport: any = [];
  arrPerformanceVsPotential: any = [];

  forReportPerformanceVsPotential() {
    // if(this.selectedPerformanceDepartments.length == 0){
    //   this.selectedperformancesBands = [];
    //   this.selectedPerformanceEmployee = [];
    //   return;
    // }
    let filteredData: any = {}; // Use an object to group employees by category
    let bandData: any = [];
    let employeeData: any = [];

    if (this.arrPerformanceVsPotentialReport.length == 0) {
      this.selectedPerformanceDepartments = [];
      this.selectedperformancesBands = [];
      this.selectedPerformanceEmployee = [];
      this.arrPerformanceVsPotential = [
        {
          count: '0',
          category: 'Low performance & low potential',
          cssClass: 'enigma',
        },
        {
          count: '0',
          category: 'High performance & high potential',
          cssClass: 'growth-employee',
        },
        {
          count: '0',
          category: 'High performance & medium potential',
          cssClass: 'future-leader',
        },
        {
          count: '0',
          category: 'Low performance & medium potential',
          cssClass: 'effective',
        },
        {
          count: '0',
          category: 'Medium performance & high potential',
          cssClass: 'core-employee',
        },
        {
          count: '0',
          category: 'Low performance & high potential',
          cssClass: 'high-impact-performer',
        },
        {
          count: '0',
          category: 'Medium performance & low potential',
          cssClass: 'under-performer',
        },
        {
          count: '0',
          category: 'Medium performance & medium potential',
          cssClass: 'dilemma',
        },
        {
          count: '0',
          category: 'High performance & low potential',
          cssClass: 'trusted-professional',
        },
      ];
      return;
    }

    this.arrPerformanceVsPotentialReport?.forEach((record: any) => {
      // Ensure the category exists in filteredData (default structure)
      if (!filteredData[record?.category]) {
        filteredData[record?.category] = {
          category: record?.category,
          count: 0,
          employeeDetails: [],
          cssClass: record?.cssClass,
        };
      }

      if (record?.employeeDetails && Array?.isArray(record?.employeeDetails)) {
        record?.employeeDetails?.forEach((employee: any) => {
          if (
            this.selectedPerformanceDepartments?.some(
              (dept: any) => dept?.id == employee?.department
            )
          ) {
            // Push the employee details into the already initialized category
            if (
              this.loggedInUserRole == 'Employee' ||
              this.loggedInUserRole == 'Manager' ||
              this.loggedInUserRole == 'MD'
            ) {
              if (this.loggedInUserId == employee?.userId) {
                if (!bandData[employee?.band]) {
                  bandData.push(employee?.band);
                }
              }
            } else if (this.loggedInUserRole == 'HOD') {
              if (
                this.arrHODByUserList?.some(
                  (hod: any) => hod?.userId == employee?.userId
                )
              ) {
                if (!bandData[employee?.band]) {
                  bandData?.push(employee?.band);
                }
              }
            } else {
              if (!bandData[employee?.band]) {
                bandData?.push(employee?.band);
              }
            }
            // For Employee dropdown
            if (
              Array.isArray(this.selectedPerformanceEmployee) &&
              this.selectedPerformanceEmployee?.length > 0
            ) {
              if (
                this.loggedInUserRole == 'Employee' ||
                this.loggedInUserRole == 'Manager' ||
                this.loggedInUserRole == 'MD'
              ) {
                if (this.loggedInUserId == employee?.userId) {
                  employeeData?.push(employee);
                }
              } else if (this.loggedInUserRole == 'HOD') {
                if (
                  this.arrHODByUserList?.some(
                    (hod: any) => hod?.userId == employee?.userId
                  )
                ) {
                  employeeData?.push(employee);
                }
              } else {
                employeeData?.push(employee);
              }

              this.selectedPerformanceEmployee?.forEach((emp: any) => {
                if (emp?.name == employee?.employeeName) {
                  filteredData[record?.category].employeeDetails?.push(
                    employee
                  );
                  filteredData[record?.category].count++; // Increment count
                }
              });
            } else if (
              Array.isArray(this.selectedperformancesBands) &&
              this.selectedperformancesBands?.length > 0
            ) {
              this.selectedperformancesBands?.forEach(
                (band: { name: string }) => {
                  if (employee.band === band?.name) {
                    employeeData?.push(employee);

                    if (!filteredData[record?.category]) {
                      filteredData[record?.category] = {
                        employeeDetails: [],
                        count: 0,
                      };
                    }

                    filteredData[record?.category]?.employeeDetails?.push(
                      employee
                    );
                    filteredData[record?.category].count++; // Increment count
                  }
                }
              );
            } else {
              if (
                this.loggedInUserRole == 'Employee' ||
                this.loggedInUserRole == 'Manager' ||
                this.loggedInUserRole == 'MD'
              ) {
                if (this.loggedInUserId == employee?.userId) {
                  employeeData?.push(employee);
                  filteredData[record?.category].employeeDetails?.push(
                    employee
                  );
                  filteredData[record?.category].count++; // Increment count
                }
              } else if (this.loggedInUserRole == 'HOD') {
                if (
                  this.arrHODByUserList?.some(
                    (hod: any) => hod?.userId == employee?.userId
                  )
                ) {
                  employeeData?.push(employee);
                  filteredData[record?.category]?.employeeDetails?.push(
                    employee
                  );
                  filteredData[record?.category].count++; // Increment count
                }
              } else {
                if (!employeeData[employee]) {
                  employeeData?.push(employee);
                }
                filteredData[record?.category]?.employeeDetails?.push(employee);
                filteredData[record?.category].count++; // Increment count
              }
            }
          }
        });
      }
    });

    this.arrEmployeesReport = employeeData?.map((emp: any, index: any) => ({
      id: index,
      name: emp?.employeeName,
    }));

    const uniqueBandData = Array.from(new Set(bandData));

    this.bandListForPerformanceVsPotential = uniqueBandData?.map(
      (emp: any, index: number) => ({
        id: index,
        name: emp,
      })
    );

    if (
      this.loggedInUserRole == 'Employee' ||
      this.loggedInUserRole == 'Manager' ||
      this.loggedInUserRole == 'MD'
    ) {
      this.selectedperformancesBands?.push(
        this.bandListForPerformanceVsPotential[0]
      );

      if (this.arrEmployeesReport?.length > 0) {
        this.selectedPerformanceEmployee = [this.arrEmployeesReport[0]];
      }
    } else {
      if (this.arrEmployeesReport?.length > 0) {
        // this.selectedperformancesBands=[];
        // this.selectedPerformanceEmployee = [this.arrEmployeesReport[0]];
      } else {
        this.selectedPerformanceEmployee = [];
      }
    }

    this.arrPerformanceVsPotential = Object?.values(filteredData);
  }

  bandListForPerformanceVsPotential: any[] = [];

  // performance employee dropdown

  onPerformanceEmployeeSelect() {
    this.selectedCountForPerformanceVsPotentialEmployee =
      this.selectedPerformanceEmployee.length;
    this.forReportPerformanceVsPotential();
  }

  onPerformanceEmployeeDeSelect() {
    this.selectedCountForPerformanceVsPotentialEmployee =
      this.selectedPerformanceEmployee.length;
    this.forReportPerformanceVsPotential();
  }

  onSelectAllPerformanceEmployees(event: any) {
    this.selectedCountForPerformanceVsPotentialEmployee =
      this.selectedPerformanceEmployee.length;
    this.selectedPerformanceEmployee = event;
    this.forReportPerformanceVsPotential();
  }

  onDeSelectAllPerformanceEmployees() {
    this.selectedCountForPerformanceVsPotentialEmployee = 0;
    this.forReportPerformanceVsPotential();
  }

  emptyReportPerformanceVsPotential() {
    let filteredData: any = {}; // Use an object to group employees by category
    let bandData: any = [];
    let employeeData: any = [];

    this.arrPerformanceVsPotentialReport.forEach((record: any) => {
      // Ensure the category exists in filteredData (default structure)
      if (!filteredData[record?.category]) {
        filteredData[record?.category] = {
          category: record?.category,
          count: 0,
          employeeDetails: [],
          cssClass: record?.cssClass,
        };
      }
    });

    this.arrEmployeesReport = [];

    this.bandListForPerformanceVsPotential = [];
    this.selectedPerformanceEmployee = [];
    this.selectedperformancesBands = [];
    this.arrPerformanceVsPotential = Object?.values(filteredData);
  }

  // ***********************************

  // ****************Employee trends Across Report*********************

  // Employee List
  currentEmployeeList: any[] = [];
  selectedEmployees: any[] = [];
  allEmployeeTrendData: any[] = []; //

  getEmployeeTrends() {
    const apiUrl = `${
      this.config.employeeTrendsReports + this.loggedInUserCompanyID
    }`;

    // this.employeeTrendsScore
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        if (response && response?.data) {
          // this.employeetrendAccrossyear = response.data;

          this.currentEmployeeList = response.data;
          this.allEmployeeTrendData = [...response.data];

          this.trendFilterData();
          let departmentNames = this.selectedDepartmentEmployeeTrends.map(
            (dept: any) => dept?.id
          );

          let filteredData = this.currentEmployeeList?.filter((employee: any) =>
            departmentNames?.includes(employee.department)
          );

          if (this.loggedInUserRole == 'HOD') {
            filteredData = filteredData?.filter((employee: any) =>
              this.arrHODByUserList?.some(
                (hod: any) => hod?.userId == employee?.userId
              )
            );
            this.employeetrendAccrossyear = filteredData;
          } else if (
            this.loggedInUserRole == 'Employee' ||
            this.loggedInUserRole == 'Manager' ||
            this.loggedInUserRole == 'MD'
          ) {
            filteredData = filteredData?.filter(
              (employee: any) => this.loggedInUserId == employee?.userId
            );
            this.employeetrendAccrossyear = filteredData;
          } else {
            this.employeetrendAccrossyear = filteredData;
          }

          this.extractBandsAndEmployees(this.employeetrendAccrossyear);
          // this.selectedEmployeeTrends =  this.extractBandsAndEmployees;
        } else {
          console.warn('No trends data received');
          this.employeetrendAccrossyear = [];
        }
      },
      error: (err: any) => {},
    });
  }

  //departmentmentwise  filter

  selectedDepartmentEmployeeTrends: any = [];

  getSelectededEmployeeTrends() {
    this.trendFilterData();
    // this.getEmployeeTrends();
  }

  getDeSelectedEMployeeTrends() {
    // this.selectedDepartmentEmployeeTrends = [];
    this.selectedtrendsBands = [];
    this.selectedEmployeeTrends = [];
    this.trendFilterData();
    // this.getEmployeeTrends();
  }
  selectAllEmployeeTrends(event: any) {
    this.selectedDepartmentEmployeeTrends = event;
    // this.getEmployeeTrends();

    this.trendFilterData();
  }

  onDeSelectAllEmployeeTrends() {
    this.selectedDepartmentEmployeeTrends = [];
    this.selectedtrendsBands = [];
    this.selectedEmployeeTrends = [];
    this.trendFilterData();
    // this.getEmployeeTrends();
  }

  trendFilterData() {
    let departmentNames = this.selectedDepartmentEmployeeTrends?.map(
      (dept: any) => dept?.id
    );

    let filteredData = this.currentEmployeeList?.filter((employee: any) =>
      departmentNames?.includes(employee?.department)
    );

    this.uniqueBands = [];
    this.uniqueEmployees = [];

    if (this.selectedDepartmentEmployeeTrends?.length === 0) {
      this.employeetrendAccrossyear = [];
      this.flattenTrends();
      return;
    }

    if (this.loggedInUserRole == 'HOD') {
      filteredData = filteredData?.filter((employee: any) =>
        this.arrHODByUserList?.some(
          (hod: any) => hod?.userId == employee?.userId
        )
      );
    } else if (
      this.loggedInUserRole == 'Employee' ||
      this.loggedInUserRole == 'Manager' ||
      this.loggedInUserRole == 'MD'
    ) {
      filteredData = filteredData?.filter(
        (employee: any) => this.loggedInUserId == employee?.userId
      );
    }

    // ✨ IMPORTANT FIX: Attach trends array so AG-Grid gets data
    filteredData = filteredData.map((emp: any) => ({
      ...emp,
      trends: emp.trends || [], // <-- REQUIRED for flattenTrends()
    }));

    this.employeetrendAccrossyear = filteredData;

    // ✨ THIS LINE MAKES AG-GRID UPDATE
    this.flattenTrends();
  }

  // bandwise filter data
  selectedtrendsBands: any = [];

  bandDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };

  onBandSelect() {
    this.bandFilterData();
  }

  onBandDeSelect() {
    this.selectedEmployeeTrends = [];
    this.bandFilterData();
  }

  onSelectAllBands(event: any) {
    this.selectedtrendsBands = event;
    this.bandFilterData();
  }

  onDeSelectAllBands() {
    this.selectedtrendsBands = [];
    this.selectedEmployeeTrends = [];
    this.trendFilterData();
  }
  // ------------------------------------- Band-wise Filter Function ----------------------------------
  bandFilterData() {
    if (!Array.isArray(this.selectedtrendsBands)) {
      this.selectedtrendsBands = [];
    }

    const departmentIds = (this.selectedDepartmentEmployeeTrends || []).map(
      (dept: any) => dept.id
    );
    const bandNames = (this.selectedtrendsBands || []).map(
      (band: any) => band.name
    );

    // 🔹 Start from ALL trend data (same as employeeFilterData)
    let filteredData = (this.allEmployeeTrendData || []).filter(
      (employee: any) =>
        (departmentIds.length
          ? departmentIds.includes(employee.department)
          : true) &&
        (bandNames.length ? bandNames.includes(employee.band) : true)
    );

    // 🔹 Apply role-based filter (same as employeeFilterData)
    if (this.loggedInUserRole === 'HOD') {
      filteredData = filteredData.filter((employee: any) =>
        this.arrHODByUserList?.some(
          (hod: any) => hod.userId === employee.userId
        )
      );
    } else if (
      this.loggedInUserRole === 'Employee' ||
      this.loggedInUserRole === 'Manager' ||
      this.loggedInUserRole === 'MD'
    ) {
      filteredData = filteredData.filter(
        (employee: any) => this.loggedInUserId === employee.userId
      );
    }

    // 🔹 Ensure trends exists (important for flattenTrends)
    filteredData = filteredData.map((emp: any) => ({
      ...emp,
      trends: emp.trends || [],
    }));

    // 🔹 Update main list for grid
    this.employeetrendAccrossyear = filteredData;

    // 🔹 Rebuild Employee dropdown based on current band+dept selection
    this.uniqueEmployees = (filteredData || [])
      .map((emp: any, index: number) => ({
        id: emp.userId ?? index,
        name: emp.employee,
      }))
      .filter(
        (emp, index, self) =>
          index === self.findIndex((e) => e.name === emp.name)
      );

    this.selectedEmployeeTrends = [];

    // 🔥 NOW UPDATE AG-GRID
    this.flattenTrends();
  }

  //-------------------------------- Employeewise   filter -----------------------------------

  employeeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };

  extractBandsAndEmployees(data: any[]) {
    if (data && Array.isArray(data)) {
      this.uniqueBands = Array.from(
        new Set(data?.map((emp) => emp?.band))
      )?.sort();

      this.uniqueBands = Array.isArray(this.uniqueBands)
        ? this.uniqueBands.map((band, index) => ({
            id: index,
            name: band,
          }))
        : [];

      if (this.uniqueBands.length > 0) {
        if (
          this.loggedInUserRole == 'Employee' ||
          this.loggedInUserRole == 'Manager' ||
          this.loggedInUserRole == 'MD'
        ) {
          this.selectedtrendsBands = [this.uniqueBands[0]];
        }
      }

      this.uniqueEmployees = Array.isArray(data)
        ? data
            .map((emp, index) => ({
              id: index,
              name: emp?.employee,
            }))
            .filter(
              (emp, index, self) =>
                index === self.findIndex((e) => e.name === emp.name)
            )
        : [];
    } else {
      this.uniqueBands = [];
      this.uniqueEmployees = [];
    }

    if (this.uniqueEmployees.length > 0) {
      if (
        this.loggedInUserRole == 'Employee' ||
        this.loggedInUserRole == 'Manager' ||
        this.loggedInUserRole == 'MD'
      ) {
        this.selectedEmployeeTrends = [this.uniqueEmployees[0]];
      }
    }
  }

  selectedEmployeeTrends: any = [];

  onEmployeeSelect() {
    this.employeeFilterData();
  }

  onEmployeeDeSelect() {
    this.trendFilterData();
  }
  onSelectAllEmployees(event: any) {
    // this.selectedEmployeeTrends = event;
    this.trendFilterData();
  }
  onDeSelectAllEmployees() {
    this.selectedEmployeeTrends = [];
    this.trendFilterData();
  }

  employeeFilterData() {
    const selectedEmployeeNames = (this.selectedEmployeeTrends || []).map(
      (employee: any) => employee.name
    );
    const departmentIds = (this.selectedDepartmentEmployeeTrends || []).map(
      (dept: any) => dept.id
    );
    const bandNames = (this.selectedtrendsBands || []).map(
      (band: any) => band.name
    );

    let filteredData = (this.allEmployeeTrendData || []).filter(
      (employee: any) =>
        departmentIds.length
          ? departmentIds.includes(employee.department)
          : true
    );

    if (selectedEmployeeNames.length > 0) {
      filteredData = filteredData.filter((employee: any) =>
        selectedEmployeeNames.includes(employee.employee)
      );
    } else if (bandNames.length > 0) {
      filteredData = filteredData.filter((employee: any) =>
        bandNames.includes(employee.band)
      );
    }

    if (this.loggedInUserRole === 'HOD') {
      filteredData = filteredData.filter((employee: any) =>
        this.arrHODByUserList.some((hod: any) => hod.userId === employee.userId)
      );
    } else if (
      this.loggedInUserRole === 'Employee' ||
      this.loggedInUserRole === 'Manager' ||
      this.loggedInUserRole === 'MD'
    ) {
      filteredData = filteredData.filter(
        (employee: any) => this.loggedInUserId === employee.userId
      );
    }

    // 🔹 Ensure we keep trends
    filteredData = (filteredData || []).map((emp: any) => ({
      ...emp,
      trends: emp.trends || [],
    }));

    this.employeetrendAccrossyear = filteredData;

    // 🔥 REFRESH GRID
    this.flattenTrends();
  }

  // **************** End Employee trends Across Report*********************

  // --------------------------------------------------------End Report---------------------------------------------------------------------

  closePositioning() {
    this.isPositioning = false;
    this.isPositioningFormDisabled = false;
  }
  savePositioning() {
    this.isPositioning = false;
    this.isPositioningFormDisabled = false;
  }

  getScoreToFinalConverterIndividual() {
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  saveData() {
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  departments: string[] = [];

  // Define the type of groupedData explicitly
  groupedData: { [key: string]: any[] } = {};
  filteredData: { [key: string]: any[] } = {};

  showEmployeeList(event: MouseEvent, employees: string[]) {
    this.hoveredEmployees = employees;
    this.popupStyle = {
      top: `${event?.clientY + 10}px`,
      left: `${event?.clientX + 10}px`,
    };
  }

  hideEmployeeList() {
    this.hoveredEmployees = [];
  }

  // ---------------------------------------  Download Nine Box Master Performance VS Potential -----------------------------

  downloadNineBoxPDF(type: any, idSelectorType: any): void {
    const currentDate = new Date();
    const todayDate = `${currentDate?.getFullYear()}-${(
      currentDate?.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${currentDate
      ?.getDate()
      ?.toString()
      ?.padStart(2, '0')}`;
    var idSelector = idSelectorType;
    //Call the common function from the service
    this.PdfDownload?.downloadPDF(
      idSelector, // chartId
      type, // Title
      '', // Year
      '', // From Date
      ''
    );
  }

  // ----------------------------------------  Download Nine Box Master ----------------------------------------

  downloadCSV() {
    const header = [
      'Band',
      'Employee',
      'Questions',
      'Wt(%)',
      'Score By HOD',
      'Total Score',
      'Final Score',
    ];
    const csvRows = [header];

    this.nineboxData?.forEach((employee: any) => {
      employee?.questions?.forEach((q: any, index: number) => {
        csvRows?.push([
          index === 0 ? employee?.band : '',
          index === 0 ? `${employee?.firstName} ${employee?.lastName}` : '',
          q?.question,
          q?.weightage,
          q?.hodScore,
          q?.totalScore,
          index === employee?.questions?.length - 1 ? employee?.finalScore : '',
        ]);
      });
    });

    let csvContent =
      'data:text/csv;charset=utf-8,' +
      csvRows?.map((row) => row.join(','))?.join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document?.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'nineBoxMaster.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ---------------------------------------------- Download Dump Report ---------------------------------------------------

  downloaDumpReport() {
    const header = [
      'Department',
      'Band',
      'Employee',
      'Questions',
      'Wt(%)',
      'Score By HOD',
      'Total Score',
      'Final Score',
      'PMS Score',
      'Category',
    ];
    const csvRows = [header];

    if (!this.groupedData || typeof this.groupedData !== 'object') {
      return;
    }

    const employeesArray = Object?.values(this.groupedData)?.reduce(
      (acc, val) => acc?.concat(val),
      []
    );

    if (!Array.isArray(employeesArray) || employeesArray?.length === 0) {
      return;
    }

    employeesArray?.forEach((employee: any) => {
      if (!Array.isArray(employee?.questions)) {
        return;
      }

      employee?.questions?.forEach((q: any, index: number) => {
        csvRows?.push([
          index === 0 ? employee?.department : '',
          index === 0 ? employee?.band : '',
          index === 0 ? `${employee?.firstName} ${employee?.lastName}` : '',
          q?.question,
          q?.weightage,
          q?.hodScore,
          q?.totalScore,
          index === employee?.questions.length - 1 ? employee?.finalScore : '',
          index === employee?.questions.length - 1 ? employee?.kpiScore : '',
          index === employee?.questions.length - 1 ? employee?.category : '',
        ]);
      });
    });

    let csvContent =
      'data:text/csv;charset=utf-8,' +
      csvRows?.map((row) => row?.join(','))?.join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'dumpReport.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ----------------------------------------------- Download Trend Report -------------------------------------------

  downloadTrendReport() {
    const header = [
      'Year',
      'Employee',
      'Band',
      'Department',
      'Potential Score',
      'Performance Score',
      '9 Box Category',
    ];
    const csvRows = [header];

    this.employeetrendAccrossyear?.forEach((employee: any) => {
      employee?.trends?.forEach((trend: any) => {
        csvRows.push([
          trend?.year,
          employee?.employee,
          employee?.band,
          employee?.department,
          trend?.totalScore,
          trend?.kpiScore,
          trend?.category,
        ]);
      });
    });

    let csvContent =
      'data:text/csv;charset=utf-8,' +
      csvRows.map((row) => row.join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'nineBoxTrendsReports.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ====================================================== Search Filters =====================================================

  // --------------------------- Nine box master search filter ----------------------------------------

  filteredNineBox: any[] = [];
  searchTerm: string = '';
  searchDataNineBox: any = null;

  filterNineBoxMaster(searchTerm: string) {
    const normalizedSearchTerm = searchTerm?.trim()?.toLowerCase();

    if (!normalizedSearchTerm) {
      if (this.searchDataNineBox) {
        this.nineboxData = this.searchDataNineBox;
        this.searchDataNineBox = null;
      } else {
        this.NineBoxMasterDepartmentChange(this.selectDepartname);
      }
      return;
    }

    // Backup original data only once on first search
    if (!this.searchDataNineBox) {
      this.searchDataNineBox = JSON.parse(JSON.stringify(this.nineboxData));
    }

    const filterBySearchTerm = (searchKey: any[]) =>
      searchKey?.filter((ninebox: any) => {
        const fullName = `${(ninebox?.firstName ?? '')?.trim()} ${(
          ninebox?.lastName ?? ''
        )?.trim()}`
          ?.trim()
          ?.toLowerCase();

        const matchesQuestionData = ninebox?.questions?.some(
          (q: any) =>
            q?.question
              ?.toString()
              ?.toLowerCase()
              ?.includes(normalizedSearchTerm) ||
            (q?.weightage != null &&
              q.weightage.toString().includes(normalizedSearchTerm)) ||
            (q?.hodScore != null &&
              q.hodScore.toString().includes(normalizedSearchTerm)) ||
            (q?.totalScore != null &&
              q.totalScore.toString().includes(normalizedSearchTerm))
        );

        return (
          fullName?.includes(normalizedSearchTerm) ||
          ninebox?.band
            ?.toString()
            ?.toLowerCase()
            ?.includes(normalizedSearchTerm) ||
          (ninebox?.finalScore != null &&
            ninebox?.finalScore?.toString()?.includes(normalizedSearchTerm)) ||
          matchesQuestionData
        );
      });

    this.filteredNineBox = filterBySearchTerm(this.searchDataNineBox);
    this.nineboxData = [...this.filteredNineBox];
  }

  private resetNineBoxData() {
    this.nineboxData = [...this.arrNineBoxMasterData];
  }

  // =================== Search filter for Dump report =================

  searchData: any = null;
  searchDumpReport: string = '';

  filterDumpReport(searchDumpReport: string) {
    const searchTerm = searchDumpReport?.trim()?.toLowerCase();

    if (!searchTerm) {
      if (this.searchData) {
        this.groupedData = this.searchData;
      } else {
        this.getDashBoardDeptWise();
      }
      return;
    }

    if (!this.searchData) {
      this.searchData = JSON.parse(JSON.stringify(this.groupedData));
    }

    const filterBySearchTerm = (data: any[]) =>
      data?.filter((employee: any) => {
        const fullName = `${(employee?.firstName ?? '')?.trim()} ${(
          employee?.lastName ?? ''
        )?.trim()}`.toLowerCase();

        const matchesQuestionData = employee?.questions?.some(
          (q: any) =>
            q?.question?.toString().toLowerCase().includes(searchTerm) ||
            (q?.weightage != null &&
              q?.weightage?.toString()?.includes(searchTerm)) ||
            (q?.hodScore != null &&
              q?.hodScore?.toString()?.includes(searchTerm)) ||
            (q?.totalScore != null &&
              q?.totalScore?.toString()?.includes(searchTerm))
        );

        return (
          fullName.includes(searchTerm) ||
          employee?.band?.toString()?.toLowerCase()?.includes(searchTerm) ||
          employee?.department
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchTerm) ||
          employee?.category?.toString()?.toLowerCase()?.includes(searchTerm) ||
          (employee?.finalScore != null &&
            employee?.finalScore?.toString()?.includes(searchTerm)) ||
          (employee?.kpiScore != null &&
            employee?.kpiScore?.toString()?.includes(searchTerm)) ||
          matchesQuestionData
        );
      });

    let filteredData: any = {};

    Object.entries(this.searchData).forEach(([department, employees]: any) => {
      const filteredEmployees = filterBySearchTerm(employees);
      if (filteredEmployees?.length > 0) {
        filteredData[department] = filteredEmployees;
      }
    });

    this.groupedData = filteredData;
  }

  private resetDumpReport() {
    this.groupedData = { ...this.arrDumpReport };

    this.departments = Object?.keys(this.groupedData);
  }

  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false, // ✅ small filter box under header
  };

  gridOptions: any = {
    suppressRowTransform: true,
    domLayout: 'autoHeight',
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      // floatingFilter: true,
      minWidth: 80,
      cellClass: (p: any) =>
        p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd',
    },
    rowSelection: 'single',
    singleClickEdit: true,
    stopEditingWhenCellsLoseFocus: true,
    localeText: { noRowsToShow: 'No Data Found' },
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType,
      },
    });
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    setTimeout(() => {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
        this.gridApi.hideOverlay();
      }
    }, 300);
  }

  onTrendGridReady(params: any) {
    this.trendGridApi = params.api;
    setTimeout(() => this.trendGridApi.sizeColumnsToFit(), 200);
  }

  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
  }

  onBtExport(strMsg: any) {
    const baseParams: ExcelExportParams = {
      fileName: strMsg + '_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: strMsg,
      exportAsExcelTable: {
        showRowStripes: true,
        name: strMsg,
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;
        const dateColumns = ['updatedAt', 'endDate', 'changedOn'];

        if (dateColumns.includes(cell.column.getColId()) && value) {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char: any) => char.toUpperCase());
        }

        return value;
      },
    };

    /**
     * Export only the currently-visible page of a grid API using shouldRowBeSkipped.
     * This method:
     *  - computes displayed start/end indexes for the current page
     *  - builds a Set of node ids that belong to that page
     *  - passes a shouldRowBeSkipped callback to exportDataAsExcel which skips rows not in the Set
     *
     * This avoids changing selection and works with grouping/pinned rows.
     */
    const exportCurrentPageOnly_v2 = (
      api: any,
      excelParams: ExcelExportParams
    ) => {
      if (!api) return;

      const hasPaginationMethods =
        typeof api.paginationGetCurrentPage === 'function' &&
        typeof api.paginationGetPageSize === 'function' &&
        typeof api.getDisplayedRowCount === 'function' &&
        typeof api.getDisplayedRowAtIndex === 'function';

      if (!hasPaginationMethods) {
        // fallback: export all rows if api doesn't expose pagination helpers
        api.exportDataAsExcel(excelParams);
        return;
      }

      const currentPage = api.paginationGetCurrentPage();
      const pageSize = api.paginationGetPageSize();
      const displayedCount = api.getDisplayedRowCount();
      const start = currentPage * pageSize;
      const end = Math.min(start + pageSize, displayedCount);

      // build a set of node ids for rows visible on the current page
      const pageNodeIds = new Set<string>();
      for (let i = start; i < end; i++) {
        const node = api.getDisplayedRowAtIndex(i);
        if (node) pageNodeIds.add(node.id);
      }

      // pass shouldRowBeSkipped: skip any row whose node.id is not in the pageNodeIds set
      api.exportDataAsExcel({
        ...excelParams,
        shouldRowBeSkipped: ({ node }: { node: any }) => {
          // If node is a group or pinned row you may want to include/exclude accordingly.
          // Here we include only rows whose id is in pageNodeIds.
          return !pageNodeIds.has(node.id);
        },
      });
    };

    // route exports to the appropriate API
    if (strMsg === 'Nine Box Master') {
      if (this.nineBoxGridApi) {
        exportCurrentPageOnly_v2(this.nineBoxGridApi, baseParams);
      }
      return;
    }

    if (strMsg === 'Dump - Report') {
      if (this.gridApi) {
        exportCurrentPageOnly_v2(this.gridApi, baseParams);
      }
      return;
    }

    if (strMsg === 'Employee Trend - Details') {
      if (this.trendGridApi) {
        exportCurrentPageOnly_v2(this.trendGridApi, baseParams);
      }
      return;
    }

    // fallback: export nothing or handle additional cases
  }

  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      APPROVED_BY_FINANCE_BUT_NOT_PAID: '#4caf50', // green
      APPROVED_BY_MANAGER_SENT_TO_FINANCE: '#4caf50',
      APPROVED_BY_MANAGER_REJECTED_BY_FINANCE: '#f44336', // red
      REJECTED_BY_MANAGER: '#f44336',
      PENDING_WITH_MANAGER: '#ff9800', // orange
    };

    // 🔹 Default color = grey
    const color = Object.keys(statusColors).find((key) =>
      valueUpper.includes(key)
    )
      ? statusColors[
          Object.keys(statusColors).find((key) => valueUpper.includes(key))!
        ]
      : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  };

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  onDumpRowClicked(event: any) {}
  onTrendRowClicked(event: any) {
    this.isDetailsOpen = true; // Open sidenav
    this.selectedRow = event.data;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isDumpResetClicked = false;
  isTrendResetClicked = false;
  searchTaskString: string = '';

  resetGrid() {
    this.isDumpResetClicked = false; // Trigger animation
    setTimeout(() => {
      this.isDumpResetClicked = false;
    }, 500);

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState(); // ✅ Reset columns
    }
  }

  resetTrendGrid() {
    this.isTrendResetClicked = false; // Trigger animation reset if needed
    setTimeout(() => {
      this.isTrendResetClicked = false;
    }, 500);

    if (this.trendGridApi) {
      // ✅ Clear all filters
      this.trendGridApi.setFilterModel(null);

      // ❗ If you want to clear sorting too, uncomment:
      // this.trendGridApi.setSortModel(null);

      // ✅ Clear selection
      this.trendGridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTerm = ''; // <-- make sure your trends search variable name is correct
      this.trendGridApi.setGridOption('quickFilterText', '');

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.trendGridApi.setGridOption(
        'paginationPageSize',
        this.paginationPageSize
      );
      this.trendGridApi.paginationGoToFirstPage();

      // ✅ Reset column state
      this.trendGridApi.resetColumnState();

      // Force refresh
      this.trendGridApi.refreshCells();
    }
  }
  isNineBoxResetClicked = false;

  resetNineBoxMaster() {
    if (!this.nineBoxGridApi) return;

    // Reset filters
    this.nineBoxGridApi.setFilterModel(null);

    // Reset sorting
    // this.nineBoxGridApi.setSortModel(null);

    // Reset search filter (if you have one)
    if (this.searchTaskString !== undefined) {
      this.searchTaskString = '';
    }
    this.nineBoxGridApi.setGridOption('quickFilterText', '');

    // Reset pagination
    this.paginationPageSize = 10;
    this.nineBoxGridApi.setGridOption(
      'paginationPageSize',
      this.paginationPageSize
    );
    this.nineBoxGridApi.paginationGoToFirstPage();

    // Reset column state if needed
    this.nineBoxGridApi.resetColumnState();

    // Refresh UI
    this.nineBoxGridApi.refreshCells();

    // Trigger icon animation
    this.isNineBoxResetClicked = true;
    setTimeout(() => (this.isNineBoxResetClicked = false), 500);
  }

  // -------------------------------- Start 9 Box Master

  nineBoxColumnDefs: ColDef[] = [
    {
      headerName: 'Band',
      field: 'band',
      // only span when this row is the first in the group
      rowSpan: (params) => (params.data?.isFirst ? params.data.rowSpan : 1),
      // show value only for the first row (others blank)
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Employee',
      field: 'fullName',
      rowSpan: (params) => (params.data?.isFirst ? params.data.rowSpan : 1),
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Questions',
      field: 'question',
      flex: 1,
      minWidth: 250,
      filter: false
    },
    {
      headerName: 'Wt(%)',
      field: 'weightage',
      cellClass: 'center-cell',
    },
   {
  headerName: 'Score By HOD',
  field: 'hodScore',

  cellRenderer: (params: any) => {
    // create an id for the input element
    const inputId = `hodScore_${params.node.id}`;
    const disabled = params.data?.freeze === true;
    return `
      <input id="${inputId}"
             type="text"
             inputmode="numeric"
             pattern="[0-9]*"
             value="${params.value ?? ''}"
             placeholder="type here......."
             class="ag-input-field-input ag-text-field-input w-100"
             style="text-align:center; height:32px; border:1px solid #ccc; border-radius:4px; padding:0 4px;"
             autocomplete="off"
             spellcheck="false"
             autocorrect="off"
             autocapitalize="off"
             ${disabled ? 'disabled' : ''} />
    `;
  },

  cellStyle: { textAlign: 'center' },

  onCellClicked: (params: any) => {
    const inputId = `hodScore_${params.node.id}`;
    const input = document.getElementById(inputId) as HTMLInputElement | null;
    if (!input || input.disabled) return;

    // ensure attributes
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('inputmode', 'numeric');
    input.spellcheck = false;

    // helper to compute prospective value
    const getProspective = (key: string) => {
      const selStart = input.selectionStart ?? input.value.length;
      const selEnd = input.selectionEnd ?? input.value.length;
      const before = input.value.slice(0, selStart);
      const after = input.value.slice(selEnd);
      return (before + key + after).replace(/^0+(?=\d)/, '');
    };

    // block invalid keypresses
    input.onkeypress = (evt: KeyboardEvent) => {
      const key = evt.key;
      if (key.length > 1) return;
      if (!/^\d$/.test(key)) {
        evt.preventDefault();
        return;
      }
      const prospective = getProspective(key);
      if (prospective.length > 3) {
        evt.preventDefault();
        return;
      }
      const n = Number(prospective === '' ? NaN : prospective);
      if (!isNaN(n) && n > 100) {
        evt.preventDefault();
        return;
      }
    };

    // main input handler — DO NOT refresh hodScore cell itself while editing
    input.oninput = () => {
      // preserve caret
      const prevSelStart = input.selectionStart ?? input.value.length;
      const prevSelEnd = input.selectionEnd ?? input.value.length;

      // sanitize
      let cleaned = input.value.replace(/[^\d]/g, '');
      if (cleaned.length > 1 && cleaned.startsWith('0')) cleaned = String(Number(cleaned));

      let valNum: number;
      if (cleaned === '') {
        // keep input visually empty; model uses 0 (or null if you prefer)
        valNum = 0;
        input.value = '';
      } else {
        valNum = Number(cleaned);
        if (isNaN(valNum)) {
          valNum = 0;
          input.value = '';
        } else if (valNum > 100) {
          valNum = 100;
          input.value = '100';
        } else {
          input.value = String(valNum);
        }
      }

      // update model hodScore (keeps it numeric)
      params.data.hodScore = valNum;

      // --- compute per-question total using weightage (weightage must be numeric, e.g. 30 for 30%) ---
      const rawWeight = params.data.weightage;
      let weight = 0;
      if (rawWeight !== undefined && rawWeight !== null) {
        // handle cases like '30' or '30%' or number
        const wStr = String(rawWeight).replace('%', '').trim();
        weight = Number(wStr) || 0;
      }
      params.data.totalScore = +(valNum * (weight / 100)); // numeric

      // --- recompute finalScore for the employee by summing all rows with same userId ---
      const userIdKey = params.data.userId ?? params.data.userID ?? params.data.user; // fallback checks
      let finalSum = 0;
      const matchingNodes: any[] = [];
      params.api.forEachNode((node: any) => {
        if (node && node.data) {
          const nodeUserId = node.data.userId ?? node.data.userID ?? node.data.user;
          if (nodeUserId === userIdKey) {
            finalSum += Number(node.data.totalScore) || 0;
            matchingNodes.push(node);
          }
        }
      });

      // assign finalScore on the 'isFirst' node (display once per employee) — fallback: assign to all matching rows
      let assigned = false;
      matchingNodes.forEach((node: any) => {
        if (node.data && node.data.isFirst) {
          node.data.finalScore = finalSum;
          assigned = true;
        }
      });
      if (!assigned) {
        // if no isFirst found, set on all matching rows
        matchingNodes.forEach((node: any) => {
          if (node.data) node.data.finalScore = finalSum;
        });
      }

      // refresh totalScore and finalScore cells for this row and other rows that show finalScore
      try {
        // refresh the edited row
        params.api.refreshCells({
          rowNodes: [params.node],
          columns: ['totalScore'],
          force: true,
        });

        // refresh all matching rows for finalScore display (only necessary if finalScore cell is shown on other rows)
        matchingNodes.forEach((node: any) => {
          params.api.refreshCells({
            rowNodes: [node],
            columns: ['finalScore'],
            force: true,
          });
        });
      } catch (e) {
        console.warn('Partial refresh failed', e);
      }

      // restore focus/caret after grid partial refresh
      setTimeout(() => {
        const newInput = document.getElementById(inputId) as HTMLInputElement | null;
        if (newInput) {
          try {
            newInput.focus();
            const len = newInput.value.length;
            const start = Math.min(prevSelStart, len);
            const end = Math.min(prevSelEnd, len);
            newInput.setSelectionRange(start, end);
          } catch (err) {
            // ignore
          }
        }
      }, 0);

      // notify parent (debounced) to persist or recompute server-side
      if (params.data.hodScore >= 0) {
        try {
          const parent = params.context?.componentParent;
          if (parent && typeof parent.onHodScoreChange === 'function') {
            parent.onHodScoreChange(params.data, params.data);
          } else if (typeof (this as any).onHodScoreChange === 'function') {
            (this as any).onHodScoreChange(params.data, params.data);
          }
        } catch (err) {
          console.warn('Failed to call onHodScoreChange', err);
        }
      }
    };

    // initial focus and move caret to end when clicked
    try {
      input.focus();
      const v = input.value ?? '';
      input.setSelectionRange(v.length, v.length);
    } catch (err) {
      // ignore focus errors
    }
  },
}

,

    {
      headerName: 'Total Score',
      field: 'totalScore',
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Final Score',
      field: 'finalScore',
      rowSpan: (params) => (params.data?.isFirst ? params.data.rowSpan : 1),
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      valueFormatter: (params: any) => {
        if (params.value && !isNaN(params.value)) {
          return Number(params.value).toFixed(2);
        }
        return params.value || ''; // blank if null
      },
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '700' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
  ];

  //----------------------------- End 9Box MAster

  columnDefsDumpReport = [
    {
      headerName: 'Band',
      field: 'band',
      minWidth: 120,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      // show value only for the first row (others blank)
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Employee',
      field: 'employee',
      minWidth: 180,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      // show value only for the first row (others blank)
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Questions',
      field: 'question',
      flex: 1,
      minWidth: 250,
      cellRenderer: (params: any) => {
        if (!params.value) return ''; // null/undefined case me blank return karega
        const shortText =
          params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

        return `<span class="clickable-comment">${shortText}</span>`;
      },
      onCellClicked: (params: any) => {
        if (params.value) {
          params.context.componentParent.openCommentModal(
            params.value,
            'Question'
          );
        }
      },
    },
    { headerName: 'Wt(%)', field: 'weightage', width: 100, minWidth: 120 },
    {
      headerName: 'Score By HOD',
      field: 'hodScore',
      width: 130,
      minWidth: 170,
    },
    {
      headerName: 'Total Score',
      field: 'totalScore',
      width: 130,
      minWidth: 150,
    },
    {
      headerName: 'Final Score',
      field: 'finalScore',
      width: 120,
      minWidth: 150,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      valueFormatter: (params: any) => {
        if (params.value && !isNaN(params.value)) {
          return Number(params.value).toFixed(2);
        }
        return params.value || ''; // blank if null
      },
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '700' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'PMS Score',
      field: 'pmsScore',
      width: 120,
      minWidth: 150,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      valueFormatter: (params: any) => {
        if (params.value && !isNaN(params.value)) {
          return Number(params.value).toFixed(2);
        }
        return params.value || ''; // blank if null
      },
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '700' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Category',
      field: 'category',
      width: 150,
      minWidth: 150,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      valueFormatter: (params: any) => {
        if (params.value && !isNaN(params.value)) {
          return Number(params.value).toFixed(2);
        }
        return params.value || ''; // blank if null
      },
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '700' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
  ];

  autoGroupColumnDef = {
    headerName: 'Department',
    cellRendererParams: { suppressCount: true },
  };

  flattenDumpReportData() {
    // Create department-wise flattened data store
    this.flattenedDataByDept = {};

    for (const dept of this.departments) {
      const employees: any[] = this.groupedData[dept];
      if (!employees) continue;

      // Create grouping map *per department*
      const map = new Map<string, any[]>();

      employees.forEach((emp: any) => {
        if (!emp.questions || !Array.isArray(emp.questions)) return;

        emp.questions.forEach((q: any) => {
          const row = {
            department: dept,
            band: emp.band ?? '',
            employee: `${emp.firstName ?? ''} ${emp.lastName ?? ''}`.trim(),

            question: q.question ?? '',
            weightage: q.weightage ?? null,
            hodScore: q.hodScore ?? null,
            totalScore: q.totalScore ?? null,
            finalScore: emp.finalScore ?? null,
            pmsScore: emp.kpiScore ?? null,
            category: emp.category ?? '',
          };

          // 🔑 Create grouping KEY (Band + Employee + FinalScore)
          const band = row.band.toString().trim();
          const name = row.employee.toString().trim();
          const finalScoreKey =
            row.finalScore === null || row.finalScore === undefined
              ? '__NULL__'
              : String(row.finalScore).trim();

          const key = `${band}:::${name}:::${finalScoreKey}`;

          if (!map.has(key)) map.set(key, []);
          map.get(key)!.push(row);
        });
      });

      // 🔥 Flatten data with rowSpan + isFirst (per department)
      const out: any[] = [];

      map.forEach((group) => {
        group.forEach((row, idx) => {
          row.isFirst = idx === 0;
          row.rowSpan = group.length;
          out.push(row);
        });
      });

      // Store for this department only
      this.flattenedDataByDept[dept] = out;
    }

    // OLD flattenedData (single table) is now NOT used
    // this.flattenedData = output;  ❌ do not use anymore

    // IMPORTANT: AG-Grid refresh handled in HTML using department slice
  }

  columnDefsEmployeeTrend = [
    {
      headerName: 'Year',
      field: 'year',
      minWidth: 120,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      valueFormatter: (params: any) => {
        if (params.value && !isNaN(params.value)) {
          return Number(params.value).toFixed(2);
        }
        return params.value || ''; // blank if null
      },
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '700' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Employee',
      field: 'employee',
      minWidth: 150,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      // show value only for the first row (others blank)
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Band',
      field: 'band',
      minWidth: 120,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      // show value only for the first row (others blank)
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    {
      headerName: 'Department',
      field: 'department',
      minWidth: 160,
      rowSpan: (params: any) =>
        params.data?.isFirst ? params.data.rowSpan : 1,
      // show value only for the first row (others blank)
      cellRenderer: (params: any) =>
        params.data?.isFirst ? params.value ?? '' : '',
      cellClass: 'center-cell',
      cellStyle: (params: any) => ({
        textAlign: 'center',
        fontWeight: params.data?.isFirst ? '600' : '',
        background: params.data?.isFirst ? '#fff' : '',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Top border
        borderBottom: params.data?.isFirst ? '1px solid #f5f5f5' : '', // ✅ Bottom border
      }),
    },
    { headerName: 'Potential Score', field: 'potentialScore', minWidth: 180 },
    {
      headerName: 'Performance Score',
      field: 'performanceScore',
      minWidth: 210,
    },
    { headerName: '9 Box Category', field: 'category', minWidth: 180 },
  ];

  flattenTrends() {
    // 💠 1. Start with an empty list
    this.flattenedTrendData = [];

    // 💠 2. Build a Map to group rows by Employee + Band + Department
    const map = new Map<string, any[]>();

    (this.employeetrendAccrossyear || []).forEach((emp: any) => {
      (emp.trends || []).forEach((t: any) => {
        // Normalize keys
        const employeeName = (emp.employee ?? '').toString().trim();
        const band = (emp.band ?? '').toString().trim();
        const department = (emp.department ?? '').toString().trim();

        // If year should be part of grouping, include it here
        const yearKey = (t.year ?? '').toString().trim();

        // 🔑 Unique key for grouping (choose grouping logic based on your need)
        const key = `${employeeName}:::${band}:::${department}:::${yearKey}`;

        // Prepare row object
        const row = {
          year: t.year,
          employee: employeeName,
          band: band,
          department: department,
          potentialScore: t.totalScore,
          performanceScore: t.kpiScore,
          category: t.category,
        };

        // Push into group
        if (!map.has(key)) map.set(key, []);
        map.get(key)!.push(row);
      });
    });

    // 💠 3. Flatten groups and add rowSpan + isFirst
    const out: any[] = [];

    map.forEach((group) => {
      group.forEach((row, idx) => {
        row.isFirst = idx === 0; // only first row of group
        row.rowSpan = group.length; // rowspan count
        out.push(row);
      });
    });

    // 💠 5. Assign final flattened list
    this.flattenedTrendData = out;

    // 💠 6. Update AG-Grid if API is ready
    if (this.trendGridApi) {
      this.trendGridApi.setRowData(this.flattenedTrendData);
      setTimeout(() => this.trendGridApi.sizeColumnsToFit(), 200);
    }
  }
}
